import React, { Component, useEffect, useState } from "react";
import { Form } from "reactstrap";
import Modal from "react-modal";
// import ReactTooltip from "react-tooltip";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetUserAccessThunk,
  GetUserAccessThunk2,
} from "../../../pages/user/redux/userThunk";
import "../../../stylesheets/InputField.css";

import axios from "axios";
import Moment from "moment";
import { reactLocalStorage } from "reactjs-localstorage";
import { savePDF } from "@progress/kendo-react-pdf";

import {
  populateSubConditonalForm,
  replaceTemplateKeyWithFormDataViewTT,
  replaceTemplateKeyWithFormDataViewTTV2,
  fetchFormulaObjectV2,
  processFormulaObjectV2,
  fetchFormulaObjectForConditionalElementV2,
  processFormulaObjectForConditionalElementV2,
  digitAmountToWord,
  rendringInputValueStyle,
  onMultiSelectCheckBoxClick,
  fetchStringFormulaObject,
  processStringFormulaObject,
  fetchStringFormulaObjectForConditionalElementV2,
  processStringFormulaObjectForConditionalElementV2,
  fetchLegalFormulaObject,
  processLegalFormulaObject,
  processTriggerInputKeyValue,
  fetchLegalFormulaObjectForConditionalElement,
  processLegalFormulaObjectForConditionalElement,
  resetremovableKeysFormData,
  resetRemovableKeysFormData,
  // from "../../coreComponents/functions/TemplateRenderingFunctions";
} from "../../../OtherFunctions/TemplateRenderingFunctions_legal";

import {
  addDocFormData,
  AddEventDocForm,
  GetAutoFillData,
  GetHolidayExcludeForms,
  userPrefill2,
  WSGetDocFormFieldsTemplate2,
  WSGetDocFormTemplateAndInputFields,
  WSGetMyFilledOrgDocForm,
  WSGetMyFilledOrgDocForm2,
  WsGetOrgUserPreFillField2,
  WSPutOrgDocFormUserInputData,
  WSPutOrgDocFormUserInputData2,
} from "../../../configs/WebService";
import {
  apiKeyHeader,
  apiKeyHeaderMultiPartFormData,
} from "../../../configs/ApiKeys";
import {
  ordinal_suffix_of,
  month2MonthString,
  processPageBreak,
  timeTo12HourFormat,
  processPageBreakForDoc,
  processPageBreakForJsPrint,
  processPageBreakForBackEnd,
} from "../../../OtherFunctions/OtherFunctions_legal";
// from "../../OtherFunctions/OtherFunctions";
import {
  processPreFilledDataFormInput,
  processUserPrefilledForTemplate,
} from "../../../OtherFunctions/PreFilledInputDataProcess";

import {
  processDocFormDraftDataFormInput,
  processDraftForTemplate,
} from "../../../OtherFunctions/DraftDataProcess";

import { InputFieldRendring } from "../../../OtherFunctions/InputFieldRendring_legal";

import { sortFormFields } from "../../../OtherFunctions/FormRenderingFunctions_legal";
import { htmlString2Print } from "../../../OtherFunctions/OtherUIFunctions";

import AutoFill from "../../../components/Other/AutoFill";
import { getBills } from "../../../bills";
import { holidaysList } from "../../EventOrganiser/docForm/holidaysList";
import moment from "moment";
import TinyMce from "../../../components/Other/TinyMce";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../../zustand/userStore";
import Popup from "../../EventOrganiser/Popup";
import {
  fetchOrganiserEvents,
  GetActivityDetailsThunk,
} from "../../EventOrganiser/redux/eventOrganiserThunks";

const inPutFieldStart = "{";
const inPutFieldEnd = "}";
const inPutFieldStartBlank = "<span class='notFilled'>{";
const inPutFieldEndBlank = "}</span>";

class TestRunNew extends Component {
  constructor(props) {
    super(props);

    // this.userData = reactLocalStorage.getObject("mdm_org_user");
    this.userData = reactLocalStorage.getObject("mdm_org_user");
    const { location } = props;

    const query = new URLSearchParams(window.location.search);
    this.formId = query.get("formId");
    // this.formId = location?.state?.formId;
    // this.templateLanguage = location?.state?.templateLanguage || "1";

    this.componentRef = React.createRef();
    this.props = props;
    // const { state } = location || {};
    this.state = {
      userData: this.userData,
      formId: this.formId,
      storeRecordId: 0,
      gUserEmail: "",
      gUserSMSNo: "",
      gUserWhatsAppNo: "",
      showActionButtons: false,
      showOtherButton: true,
      showSendToEmailModal: false,
      showSendToSMSModal: false,
      showSendToWhatsAppModal: false,
      printDoc: false,
      selectedConditionalFormInput: {},
      selectedConditionalFormInputValue: "",
      mainFormFields: "",
      showEditor: false,
      formData: {},
      mainDocFormTemplate: "",
      originalFormTemplate: "",
      testTemplateToShow: "",
      formsFieldsDataSorted: [],
      conditionalFormInputs: {},
      userPrefilledFields: "",
      errors: "",
      docFormError: "",
      showSubmitButton: false,
      usingEditor: false,
      doSavePdfOnServer: 0,
      filledFormPdfFileUrl: "",
      additionalMessage: "",
      filledDocForm: undefined,
      draft: this.props.draft || null,
      title: props.title || "",
      changeCount: 0,
      multiSelectValueInputs: {},
      savingType: "submit",
      responseResult: [],
      showFilledForm: false,
      displayAutofillBtn: false,
      displayAutoFillPopup: false,
      autoFillData: [],
      filteredAutoFillData: [],
      isTimeSelected: false,
      selectedTime: "",
      excludeHolidayForms: [],
      hallData: [],
      selectedHallData: [],
      isHallopen: false,
      includeWaterRate: true,
      includeStandingLightRate: true,
      includeAcRate: true,
      includeOpenAreaRate: true,
      includeMountingRate: true,
      showEvents: false,
      selectedEvent: null,
      selectedActivity: null,
      eventId: location?.state?.eventId || "",
      activityId: location?.state?.activityId || "",
    };

    // this.fetchDocumentBills();
    this.getHolidaysExcludeForms();
    // this.fetchDocFormTemplateAndFormFieldsTest();
  }

  getHallDetails2 = async () => {
    if (!this.state.formData.start_date) {
      alert("Please select a start date.");
      return;
    }
    try {
      const response = await axios.get(
        `https://web1024.docmaster.in:5000/autoFill/get-halls/${this.state.formId}/${this.userData.org.id}`,
        {
          headers: apiKeyHeader(),
        }
      );

      if (response.data.data && response.data.data.length > 0) {
        this.setState({
          hallData: response.data.data,
          isHallopen: true,
        });
      } else {
        alert("No data found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Error fetching data.");
    }
  };

  async getHolidaysExcludeForms() {
    try {
      const response = await fetch(GetHolidayExcludeForms, {
        method: "GET",
        headers: apiKeyHeader(),
      });

      if (!response.ok) {
        throw new Error("Error fetching holidays");
      }

      const data = await response.json();
      Promise.all(
        data.map((each) => this.state.excludeHolidayForms.push(each.form_id))
      );
    } catch (error) {
      console.error("Error in getHolidaysExcludeForms:", error);
      alert("Error fetching holidays: " + error.message);
    }
  }

  async componentDidMount() {
    let processInitialProps = await this.processReceivedProps();
    this.setState({
      formData: processInitialProps.formData,
      testTemplateToShow: processInitialProps.testTemplateToShow,
      formsFieldsDataSorted: processInitialProps.formsFieldsDataSorted,
      title: processInitialProps.title,
    });
  }

  async fetchDocumentBills() {
    // const data = await getBills(this.formId);
    const payload = {
      form_id: this.formId,
      org_id: this.userData.org.id,
      type: "",
    };
    const response = await fetch(GetAutoFillData, {
      method: "POST",
      headers: apiKeyHeader(),
      body: JSON.stringify(payload),
    });

    const fetchedData = await response.json();
    const data = JSON.parse(fetchedData.data[0].form_data);

    // billTypeKey
    this.setState((prev) => ({
      ...prev,
      autoFillData: data,
      filteredAutoFillData: data,
    }));
  }

  async fetchDocFormTemplateAndFormFieldsTest() {
    const loader = toast.success("Loading Please Wait...", {
      position: "bottom-center",
      autoClose: 500,
    });
    try {
      const response = await axios.get(
        `${WSGetDocFormFieldsTemplate2}/${this.userData.id}/${this.formId}`,
        {
          headers: apiKeyHeader(),
        }
      );
      const responseData = response.data.result_message;
      toast.dismiss(loader);
      return {
        x: responseData.fields,
        y: responseData.template,
      };
      // return { x: null, y: null };
    } catch (error) {
      console.error("error", error);
      return { x: null, y: null };
    }
  }
  // async fetchDocFormTemplateAndFormFieldsTest() {
  //   const loader = toast.success("Loading Please Wait...", {
  //     position: "bottom-center",
  //     autoClose: 500,
  //   });

  //   const body = {
  //     formId: this.formId,
  //     templateLanguage: this.templateLanguage,
  //   };
  //   try {
  //     const response = await axios.post(
  //       // `${WSGetDocFormFieldsTemplate}/${this.userData.id}/${this.formId}`,
  //       `https://web1024.docmaster.in:5000/content/getFormFieldsAndTemplate`,
  //       body,
  //       {
  //         headers: apiKeyHeader(),
  //       }
  //     );
  //     const responseData = response.data.result_message;
  //     toast.dismiss(loader);
  //     return {
  //       x: responseData.fields,
  //       y: responseData.template,
  //     };
  //     // return { x: null, y: null };
  //   } catch (error) {
  //     console.error("error", error);
  //     return { x: null, y: null };
  //   }
  // }

  // async fetchDocFormTemplateAndFormFields() {
  //   const loader = toast.success("Loading Please Wait...", {
  //     position: "bottom-center",
  //     autoClose: 500,
  //   });
  //   try {
  //     const response = await axios.post(
  //       WSGetDocFormTemplateAndInputFields,
  //       JSON.stringify({
  //         formId: this.formId,
  //         adminUserId: this.userData.id,
  //       }),
  //       {
  //         headers: apiKeyHeader(),
  //       }
  //     );
  //     const responseData = response.data;
  //     toast.dismiss(loader);
  //     return {
  //       x: responseData.forms_fields,
  //       y: responseData.forms_templates,
  //     };
  //     // return { x: null, y: null };
  //   } catch (error) {
  //     console.error("error", error);
  //     return { x: null, y: null };
  //   }
  // }

  async processReceivedProps() {
    // const { x, y } = await this.fetchDocFormTemplateAndFormFields();
    const { x, y } = await this.fetchDocFormTemplateAndFormFieldsTest();

    this.setState({
      mainDocFormTemplate: y,
      originalFormTemplate: y,
      mainFormFields: x.formFields,

      // pageType: x.pageType,
      // printMarginBottom: x.printMarginBottom,
      // printMarginLeft: x.printMarginLeft,
      // printMarginRight: x.printMarginRight,
      // printMarginTop: x.printMarginTop
    });

    // let tempFormsFieldSorted = sortFormFields(x.formFields);

    let tempFormsFieldSorted;

    if (this.props.from === "draft") {
      tempFormsFieldSorted = sortFormFields(
        this.props.formsFieldsData?.formFields
      );
    } else {
      tempFormsFieldSorted = sortFormFields(x?.formFields);
    }

    let tempConditionalFormInputs = {};
    let tempTestTemplateToShow = y;
    let formData = {};

    let title = this.props.title || "";

    if (this.props?.draft?.id != undefined && this.props?.draft?.id > 0) {
      formData = this.props.draft?.inputData;

      tempTestTemplateToShow = this.props.draft?.htmlData;
      let tempFormsFieldSortedReturn = processDocFormDraftDataFormInput(
        tempFormsFieldSorted,
        formData
      );

      tempConditionalFormInputs =
        tempFormsFieldSortedReturn.conditionalFormInputs;
    } else if (
      this.props?.oldFilledData != null &&
      this.props?.oldFilledData != undefined &&
      Object.keys(this.props?.oldFilledData?.data).length > 0
    ) {
      formData = this.props?.oldFilledData?.data.inputData;
      tempTestTemplateToShow = this.props?.oldFilledData?.data.htmlData;

      let tempFormsFieldSortedReturn = processDocFormDraftDataFormInput(
        tempFormsFieldSorted,
        formData
      );
      tempConditionalFormInputs =
        tempFormsFieldSortedReturn.conditionalFormInputs;

      title = this.props?.oldFilledData?.title;
    } else {
      if (this.props.userPrefilledFields?.length > 0) {
        tempFormsFieldSorted = processPreFilledDataFormInput(
          tempFormsFieldSorted,
          this.props.userPrefilledFields,
          this.props.filledDocForm,
          "usr"
        );
      }
    }

    return {
      testTemplateToShow: tempTestTemplateToShow,
      formsFieldsDataSorted: tempFormsFieldSorted,
      conditionalFormInputs: tempConditionalFormInputs,
      formData: formData,
      title: title,
    };
  }

  async componentDidUpdate() {
    if (!this.state.usingEditor) {
      let template = this.replaceTemplateKeyWithFormDataView(
        this.state.mainDocFormTemplate,
        this.state.formData
      );

      if (
        this.state.changeCount == 0 &&
        this.props?.draft?.id != undefined &&
        this.props?.draft?.id > 0
      ) {
        //DevNote[AddedOn]:18-08-2022
        this.processAsPerUserDraftFields();
      } else {
        if (this.state.testTemplateToShow !== template) {
          this.setState({ testTemplateToShow: template });
        }
      }
      this.state.changeCount = this.state.changeCount + 1;
    }

    // for dislpaying autofill btn
    this.state.displayAutofillBtn = false;

    const [filteredData] =
      this.state.autoFillData?.length > 0
        ? this.state.autoFillData?.filter(
            (each) =>
              this.state.formData[each.billTypeKey] === each.billTypeValue
          )
        : [];

    const formData = this.state.formData;
    if (
      formData[`${filteredData?.keys.prefix}types0`] === "Single" ||
      (formData[`${filteredData?.keys.prefix}types0`] === "Multiple" &&
        formData[`${filteredData?.keys.multipleKey}`] > 0) ||
      formData[`${filteredData?.keys.multipleKey}`] > 0 ||
      formData["pum_totaltypes0"] > 0
    ) {
      const type =
        formData[`${filteredData?.keys.prefix}types0`] === "Single"
          ? "Single"
          : "Multiple";
      this.state.displayAutofillBtn = true;
      this.state.filteredAutoFillData = { ...filteredData, type };
    }
  }

  //DevNote[AddedOn]:18-08-2022
  processAsPerUserDraftFields() {
    this.state.formsFieldsDataSorted?.map((formsFieldsData) => {
      console.log(
        "processAsPerUserDraftFields_formsFieldsData",
        formsFieldsData
      );
      // this.processOtherCondition(formsFields, formsFieldsData.for)
      let templateKey = formsFieldsData.elementUId;
      if (
        formsFieldsData.otherConditions !== undefined &&
        formsFieldsData.otherConditions?.length > 0
      ) {
        this.processOtherCondition(formsFieldsData, templateKey);
      }

      let tempValue = this.state.formData[templateKey];
      if (formsFieldsData.isConditional == true) {
        // console.log("formsFieldsData.isConditional", "-----------------------");

        this.setState({
          selectedConditionalFormInputValue: tempValue?.trim(),
          selectedConditionalFormInput: formsFieldsData,
        });

        //Way 1
        // this.state.conditionalFormInputs[formsFieldsData.elementUId] = {
        //   inputValue: e.target.value.trim(),
        //   input: formsFieldsData,
        // };

        let valueKey = null;
        let multiSelectValue = []; //AddedOn 13-12-2021
        //For Selectv2
        if (formsFieldsData.elementType.toLowerCase() === "selectv2") {
          valueKey = tempValue.split(":")[0];
          tempValue = tempValue.split(":")[1];
        }

        if (formsFieldsData.elementType.toLowerCase() == "checkbox") {
          if (
            formsFieldsData.elementConfig.type.toLowerCase() ==
              "multiselectt1" ||
            formsFieldsData.elementConfig.type.toLowerCase() ==
              "multiselectt2" ||
            formsFieldsData.elementConfig.type.toLowerCase() ==
              "multiselectt3" ||
            formsFieldsData.elementConfig.type.toLowerCase() ==
              "multiselectt4" ||
            formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt5"
          ) {
            // tempValue = event.target.value.trim();//AddedOn 13-12-2021
            multiSelectValue = tempValue
              ?.split(",")
              .map(function (value) {
                return value.trim();
              })
              .filter(function (i) {
                return i;
              });

            tempValue = onMultiSelectCheckBoxClick(
              tempValue,
              formsFieldsData.elementConfig.type,
              formsFieldsData.validation.maxLength,
              formsFieldsData.validation.minLength
            );
            console.log(
              "multiselectt1_tempValue_formsFieldsData.elementConfig.type",
              formsFieldsData.elementConfig.type
            );
            console.log("multiselectt1_tempValue", tempValue);
            //   multiSelectValue = event.target.tempValue; //DevNote: ToBeDone
            console.log(
              "multiselectt1_tempValue_multiSelectValue",
              multiSelectValue
            ); //AddedOn 13-12-2021

            console.log(
              "multiselectt1_tempValue_multiSelectValue",
              multiSelectValue
            ); //AddedOn 13-12-2021
          } /*else {
            //DevNote: ToBeDone
            //console.log("checkBoxChecked", event.target.checked);
            //   if (event.target.checked) {
            //     tempValue = event.target.value.trim();
            //   } else {
            //     tempValue = "";
            //   }
          }*/
        }
        //          valueKey: valueKey,
        this.state.conditionalFormInputs[templateKey] = {
          inputValue: tempValue?.trim(),
          input: formsFieldsData,
          templateKey: templateKey,
          multiSelectValue: multiSelectValue,
        };

        this.processConditionalFormFieldTemplate(
          // this.props.formsTemplate,
          // this.state.mainDocFormTemplate,
          this.state.originalFormTemplate,
          formsFieldsData,
          tempValue?.trim(),
          templateKey
        );
      }
    });
  }

  onInputChange = async (
    event,
    formsFieldsData,
    fieldKey,
    templateKey,
    level
  ) => {
    if (event.target.type.toLowerCase() === "time") {
      this.isTimeSelected = true;
      this.selectedTime = event.target.value;
    }

    const breakFaststartTime = "00:00 AM";
    const breakFastendTime = "10:30 AM";
    const tStarttimeMorning = "10:31 AM";
    const tEndtimeMorning = "11:59 AM";
    const tStarttimeEvening = "04:00 PM";
    const tEndtimeEvening = "05:59 PM";
    const lunchStartTime = "12:00 PM";
    const lunchendTime = "03:59 PM";
    // const tStarttime = "04:00 PM";
    // const tEndtime = "05:59 PM";
    const dinnerStarttime = "06:00 PM";
    const dinnerEndtime = "11:59 PM";

    const convertToDate = (timeString) => {
      if (!timeString) {
        console.error("Invalid timeString:", timeString);
        return null;
      }
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");
      let convertedHours = parseInt(hours);
      if (period === "AM" && convertedHours === 12) {
        convertedHours = 0;
      }
      if (period === "PM" && convertedHours !== 12) {
        convertedHours += 12;
      }
      const date = new Date();
      date.setHours(convertedHours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      return date;
    };

    if (templateKey === "for" || templateKey === "forarrangement0") {
      if (this.isTimeSelected) {
        const breakFastStart = convertToDate(breakFaststartTime);
        const breakFastEnd = convertToDate(breakFastendTime);
        const lunchStart = convertToDate(lunchStartTime);
        const lunchEnd = convertToDate(lunchendTime);
        // const tStart = convertToDate(tStarttime);
        // const tEnd = convertToDate(tEndtime);
        const tStart = convertToDate(tStarttimeEvening);
        const tEnd = convertToDate(tEndtimeEvening);
        const tStartMorn = convertToDate(tStarttimeMorning);
        const tEndtimeMorn = convertToDate(tEndtimeMorning);
        const dinnerStart = convertToDate(dinnerStarttime);
        const dinnerEnd = convertToDate(dinnerEndtime);
        const selectedTime = convertToDate(this.selectedTime);

        if (event.target.value === "Breakfast") {
          if (selectedTime >= breakFastStart && selectedTime <= breakFastEnd) {
            console.log("Selected time is within the Breakfast range.");
          } else {
            event.target.value = "";
            return alert(
              "Selected time for Breakfast should be between 12:00 AM and 10:30 AM."
            );
          }
        } else if (event.target.value === "Lunch") {
          if (selectedTime >= lunchStart && selectedTime <= lunchEnd) {
            console.log("Selected time is within the Lunch range.");
          } else {
            event.target.value = "";
            return alert(
              "Selected time for Lunch should be between 12:00 PM and 03:59 PM."
            );
          }
        }
        // else if (event.target.value === "Tea") {
        //   if (selectedTime >= tStart && selectedTime <= tEnd) {
        //     console.log("Selected time is within the Tea range.");
        //   } else {
        //     event.target.value = "";
        //     return alert(
        //       "Selected time for Tea should be between 04:00 PM and 05:59 PM."
        //     );
        //   }
        // }
        else if (event.target.value === "Tea") {
          if (
            (selectedTime >= tStart && selectedTime <= tEnd) ||
            (selectedTime >= tStartMorn && selectedTime <= tEndtimeMorn)
          ) {
            console.log("Selected time is within the Tea range.");
          } else {
            event.target.value = "";
            return alert(
              "The selected time for tea should be between 10:31 AM and 11:59 AM, or between 4:00 PM and 5:59 PM"
            );
          }
        } else if (event.target.value === "Dinner") {
          if (selectedTime >= dinnerStart && selectedTime <= dinnerEnd) {
            console.log("Selected time is within the Dinner range.");
          } else {
            event.target.value = "";
            return alert(
              "Selected time for Dinner should be between 06:00 PM and 11:59 PM."
            );
          }
        }
      } else {
        event.target.value = "";
        return alert("Please select a time first!");
      }
    }

    setTimeout(function () {
      const div = document.getElementById("contentToPrint");
      if (div) {
        const spans = div.getElementsByTagName("span");
        for (let span of spans) {
          if (
            span.textContent.includes(
              "As per The dishonour memo date you have entered"
            )
          ) {
            span.innerHTML = span.innerHTML.replace(
              "proceeding .",
              "proceeding."
            );
          }
        }
      }
    }, 1000);

    console.log("event_target_value: ", event.target.value);
    console.log("formsFieldsData_463: ", formsFieldsData);
    console.log("templateKey_464: ", templateKey);

    if (
      event.target.value === "Telephone Bill" ||
      event.target.value === "Electricity Bill" ||
      event.target.value === "Consolidated Electricity Bill" ||
      event.target.value === "Fuel Bill"
    ) {
      this.resetBills();
    }

    //ToDo: if target type is date show/convert input value in Provided Format
    let tempValue = event.target.value.trim();
    let multiSelectValue = []; //AddedOn 14-12-2021

    if (
      event.target.type.toLowerCase() == "input" ||
      event.target.type.toLowerCase() == "file"
    ) {
      if (formsFieldsData.elementConfig.type.toLowerCase() == "image") {
        tempValue =
          "<img src='" +
          URL.createObjectURL(event.target.files[0]) +
          "' alt='' width='" +
          formsFieldsData.validation.maxLength +
          "' height='" +
          formsFieldsData.validation.minLength +
          "'/>";
      }
    }

    if (event.target.type.toLowerCase() == "date") {
      let userEnteredValue = Moment(event.target.value).format("DD-MM-YYYY");
      const dayOfWeek = Moment(event.target.value).day();

      if (!this.state.excludeHolidayForms?.includes(this.state.formId)) {
        if (dayOfWeek === 0) {
          event.target.value = "";
          return alert(`Sunday is Holiday ${userEnteredValue}`);
        }
        if (holidaysList.some((each) => each.date === userEnteredValue)) {
          const holidayItem = holidaysList.find(
            (each) => each.date === userEnteredValue
          );
          alert(`Holiday: ${holidayItem.reason} (${holidayItem.date})`);
          event.target.value = "";
          return;
        }
      }
      if (formsFieldsData.elementConfig.type.toLowerCase() == "date") {
        if (formsFieldsData.value.length >= 10) {
          tempValue = Moment(tempValue).format(formsFieldsData.value); //To Change into Provided Format
        } else {
          tempValue = Moment(tempValue).format("DD-MM-YYYY"); //To Change into dd-mm-yyyy
        }
      } else if (
        formsFieldsData.elementConfig.type.toLowerCase() == "date_l1"
      ) {
        tempValue = Moment(tempValue).format("DD-MM-YYYY"); //To Change into dd-mm-yyyy
        const tempValueDate = tempValue.split("-");
        //const tempValueDay=ordinal_suffix_of(tempValueDate[0])
        //const tempValueMonth=month2MonthString(tempValueDate[1])
        //tempValue=tempValueDay+" day of "+tempValueMonth+", "+tempValueDate[2]//Old
        tempValue =
          ordinal_suffix_of(tempValueDate[0]) +
          " day of " +
          month2MonthString(tempValueDate[1]) +
          " of the year " +
          tempValueDate[2];
      } else if (
        formsFieldsData.elementConfig.type.toLowerCase() == "date_l2"
      ) {
        tempValue = Moment(tempValue).format("DD-MM-YYYY"); //To Change into dd-mm-yyyy
        const tempValueDate = tempValue.split("-");
        tempValue =
          ordinal_suffix_of(tempValueDate[0]) +
          " " +
          month2MonthString(tempValueDate[1]) +
          ", " +
          tempValueDate[2];
      } else {
        tempValue = Moment(tempValue).format("DD-MM-YYYY"); //To Change into dd-mm-yyyy
      }
    }

    //ToProcess TimePicker
    if (formsFieldsData.elementType.toLowerCase() == "time") {
      if (formsFieldsData.elementConfig.type.toLowerCase() == "time12") {
        tempValue = timeTo12HourFormat(tempValue);
      }
    }

    if (formsFieldsData.elementType.toLowerCase() == "checkbox") {
      if (
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt1" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt2" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt3" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt4" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt5"
      ) {
        // tempValue = event.target.value.trim();
        tempValue = onMultiSelectCheckBoxClick(
          tempValue,
          formsFieldsData.elementConfig.type,
          formsFieldsData.validation.maxLength,
          formsFieldsData.validation.minLength
        );
        console.log("multiselectt1_tempValue_main", tempValue);
        multiSelectValue = event.target.tempValue; //AddedOn 14-12-2021 For MultiSelectedCheckBox
        console.log(
          "multiselectt1_tempValue_multiSelectValue",
          multiSelectValue
        ); //AddedOn 13-12-2021
      } else {
        if (event.target.checked) {
          tempValue = event.target.value.trim();
        } else {
          tempValue = "";
        }
      }
    }

    //Remark[Flow]:18-04-2023 CopyOfMultiSelectValue Process
    if (
      formsFieldsData.elementType.toLowerCase() == "copyofinput" &&
      (formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt1" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt2" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt3" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt4" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt5")
    ) {
      multiSelectValue =
        this.state.multiSelectValueInputs[formsFieldsData.value];
    }

    if (formsFieldsData.elementConfig.type.toLowerCase() == "daystring") {
      if (formsFieldsData.elementType.toLowerCase() == "select") {
        //Nothing to do
      } else {
        tempValue = ordinal_suffix_of(tempValue); //Change to Day String
      }
    }

    if (formsFieldsData.elementConfig.type.toLowerCase() == "monthstring") {
      if (formsFieldsData.elementType.toLowerCase() == "select") {
        //Nothing to do
      } else {
        tempValue = month2MonthString(tempValue); //Change to Month String
      }
    }

    //Old
    //this.setState({ [event.target.name]:event.target.value.trim() });
    //this.state.formData[event.target.name] = tempValue;
    // if (
    //   formsFieldsData.otherConditions !== undefined &&
    //   formsFieldsData.otherConditions === "commaSepNum"
    // ) {
    //   //AddedOn:23-11-2021
    //   if (!isNaN(tempValue)) {
    //     //console.log("Number_WithComma",numberWithCommas(tempValue))
    //     tempValue = numberWithCommas(tempValue);
    //   }
    // }

    this.setState({ [templateKey]: tempValue.trim() });
    this.state.formData[templateKey] = tempValue.trim();
    // this.state.formData[templateKey] = tempValue.trim();
    /*//Not Needed
    if (formsFieldsData.elementType.toLowerCase() == "checkbox") {
      if (
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt1" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt2" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt3" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt4" ||
        formsFieldsData.elementConfig.type.toLowerCase() == "multiselectt5"
      ) {
        this.state.formData[templateKey] = event.target.tempValue.join();
      } else {
        this.state.formData[templateKey] = tempValue.trim();
      }
    } else {
      this.state.formData[templateKey] = tempValue.trim();
    }
    */
    this.setState({ formData: this.state.formData });
    console.log("formData_", this.state.formData);
    //DevNote: Process Below on Submit Also
    if (
      formsFieldsData.otherConditions !== undefined &&
      formsFieldsData.otherConditions.length > 0
    ) {
      this.processOtherCondition(formsFieldsData, templateKey);
    }

    if (formsFieldsData.isConditional == true) {
      this.setState({
        selectedConditionalFormInputValue: tempValue.trim(),
        selectedConditionalFormInput: formsFieldsData,
      });

      this.state.conditionalFormInputs[templateKey] = {
        inputValue: tempValue.trim(),
        input: formsFieldsData,
        templateKey: templateKey,
        multiSelectValue: multiSelectValue,
      };

      this.setState({
        conditionalFormInputs: this.state.conditionalFormInputs,
      });

      this.processConditionalFormFieldTemplate(
        // this.props.formsTemplate,
        // this.state.mainDocFormTemplate,
        this.state.originalFormTemplate,
        formsFieldsData,
        tempValue.trim(),
        templateKey,
        level
      );
    }
  };

  processOtherCondition(formsFields, mainFieldTemplateKey) {
    let conditionAction = formsFields.otherConditions.split("(")[0];
    var conditionVars = formsFields.otherConditions.substring(
      formsFields.otherConditions.indexOf("(") + 1,
      formsFields.otherConditions.lastIndexOf(")")
    );

    let parentKeyTemp = this.filterOutParentKey(
      mainFieldTemplateKey,
      formsFields.elementUId
    );
    if (parentKeyTemp != undefined && parentKeyTemp.length > 0) {
      conditionVars = conditionVars + parentKeyTemp;
    }

    if (
      this.state.formData[conditionVars] != undefined &&
      this.state.formData[mainFieldTemplateKey] != undefined
    ) {
      if (conditionAction == "lessThanEqualTo") {
        if (
          Number(this.state.formData[mainFieldTemplateKey]) <=
          Number(this.state.formData[conditionVars])
        ) {
          // console.log("processOtherCondition_conditionAction_test","Ok");
        } else {
          alert(
            "Please check input of " + formsFields.elementConfig.inputLabel
          );
        }
      }
      //AddedOn:17-11-2021
      if (conditionAction == "greaterThanEqualTo") {
        if (
          Number(this.state.formData[mainFieldTemplateKey]) >=
          Number(this.state.formData[conditionVars])
        ) {
          // console.log("processOtherCondition_conditionAction_test","Ok");
        } else {
          //alert("Please check value of "+mainFieldTemplateKey+" and "+conditionVars);
          alert(
            "Please check input of " + formsFields.elementConfig.inputLabel
          );
        }
      }
    }
  }

  filterOutParentKey(inputAndTemplateKey, fieldUid) {
    return inputAndTemplateKey.replace(fieldUid, "");
  }

  replaceTemplateKeyWithFormDataView(template, formdata) {
    formdata = processUserPrefilledForTemplate(
      // this.state.userPrefilledFields,
      this.props.docFormPreFills,
      formdata
    );

    if (this.props?.draft?.id != undefined && this.props?.draft?.id > 0) {
      // formdata = processDraftForTemplate(this.context?.formData, formdata);
      formdata = processDraftForTemplate(this.props.draft?.inputData, formdata);
    }

    console.log("replaceTemplateKeyWithFormDataView_post2", formdata);

    template = template.replace(
      new RegExp(inPutFieldStart, "gi"),
      inPutFieldStartBlank
    );
    template = template.replace(
      new RegExp(inPutFieldEnd, "gi"),
      inPutFieldEndBlank
    );
    let conditionalFormsFieldsDataSorted = [];
    let conditionalFormsFieldsDataSortedMain = [];
    //ToDo: Do Not Show Unchecked CheckBox
    if (
      this.state.mainFormFields != null &&
      this.state.mainFormFields != undefined
    ) {
      Object.entries(this.state.mainFormFields).map(([key, val]) => {
        //let formFieldObject = this.state.mainFormFields[key];
        if (val.elementType.toLowerCase() == "label") {
          formdata[key] = val.value;
        } else if (val.elementType == "copyOfInput") {
          if (formdata[val.value] != undefined) {
            const input = document.querySelector("#" + key);
            if (input != null && input != undefined) {
              // This will work by calling the native setter bypassing Reacts incorrect value change check
              Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                "value"
              ).set.call(input, formdata[val.value]);
              // This will trigger a new render wor the component
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        } else if (val.elementType.toLowerCase() == "amount2words") {
          formdata[key] = digitAmountToWord(formdata[val.value]);
        } else if (val.elementType.toLowerCase() == "formula") {
          let formulaObject = fetchFormulaObjectV2(val.value);
          var processFormulaObjectValue = processFormulaObjectV2(
            formulaObject,
            formdata
          );
          formdata[key] = processFormulaObjectValue;
        } else if (val.elementType.toLowerCase() == "strngformula") {
          //DevNote:strngformula//added on 21-02-2024
          console.log("mainFormFields", "---- strngformula ----");
          console.log("mainFormFields_strngformula_key", key);
          console.log("mainFormFields_strngformula_val.value", val.value);
          console.log(
            "mainFormFieldsformdata[key]_strngformula_" + key,
            formdata[key]
          );
          let stringFormulaObject = fetchStringFormulaObject(val.value);
          console.log(
            "mainFormFields_strngformula_formulaObject",
            stringFormulaObject
          );
          var processStringFormulaObjectValue = processStringFormulaObject(
            stringFormulaObject,
            formdata,
            val.elementConfig.type.toLowerCase()
          );
          console.log(
            "mainFormFields_strngformula_processFormulaObjectValue",
            processStringFormulaObjectValue
          );
          formdata[key] = processStringFormulaObjectValue;
          console.log(
            "mainFormFields_strngformula_processFormulaObjectValue_key",
            formdata[key]
          );
        } else if (val.elementType.toLowerCase() == "legalformula") {
          //DevNote:legalformula//added on 24-02-2024//

          console.log("mainFormFields", "---- legalformula ----");
          console.log("mainFormFields_legalformula_key", key);
          console.log("mainFormFields_legalformula_val.value", val.value);
          console.log(
            "mainFormFieldsformdata[key]_legalformula_" + key,
            formdata[key]
          );
          let stringLegalObject = fetchLegalFormulaObject(val.value);
          console.log(
            "mainFormFields_legalformula_formulaObject",
            stringLegalObject
          );
          let processLegalFormulaObjectValue = processLegalFormulaObject(
            stringLegalObject,
            formdata,
            val.elementConfig.type.toLowerCase()
          );
          console.log(
            "mainFormFields_legalformula_processFormulaObjectValue",
            processLegalFormulaObjectValue
          );
          formdata[key] = processLegalFormulaObjectValue;

          console.log(
            "mainFormFields_legalformula_processFormulaObjectValue_key",
            formdata[key]
          );
        } else if (val.elementType.toLowerCase() == "trigger") {
          //DevNote:trigger type input//added on 22-02-2024
          console.log("mainFormFields_trigger_key", key);
          let triggerKeyValue = processTriggerInputKeyValue(val.value);

          console.log(
            "mainFormFields_trigger_triggerKeyValue",
            triggerKeyValue
          );
          formdata[key] = "";

          if (
            triggerKeyValue[0] != undefined &&
            triggerKeyValue[0].length > 0 &&
            formdata[triggerKeyValue[0]] != undefined &&
            formdata[triggerKeyValue[0]].length > 0
          ) {
            console.log(
              "mainFormFields_trigger_triggerKeyValue_formdata",
              triggerKeyValue,
              formdata[triggerKeyValue[0]]
            );
            if (
              triggerKeyValue[1] != undefined &&
              triggerKeyValue[1].length > 0
            ) {
              formdata[key] = triggerKeyValue[1];
            }
            console.log(
              "mainFormFields_trigger_key_formdata",
              key,
              formdata[key]
            );
          }
        } else if (val.elementType.toLowerCase() == "checkbox") {
          if (
            val.elementConfig.type.toLowerCase() == "multiselectt1" ||
            val.elementConfig.type.toLowerCase() == "multiselectt2" ||
            val.elementConfig.type.toLowerCase() == "multiselectt3" ||
            val.elementConfig.type.toLowerCase() == "multiselectt4" ||
            val.elementConfig.type.toLowerCase() == "multiselectt5"
          ) {
            //Do Nothing
          } else {
            if (formdata[key] == undefined) {
              formdata[key] = "";
            } else {
              if (formdata[key].length > 0) {
                formdata[key] = val.value;
              } else {
                //DO Nothing
              }
            }
          }
        }
      });
    }

    if (
      this.state.conditionalFormInputs != null &&
      this.state.conditionalFormInputs != undefined
    ) {
      Object.entries(this.state.conditionalFormInputs).map(([key, val]) => {
        //Remark[Flow]:18-04-2023 CopyOfMultiSelectValue Process
        if (
          (val.input.elementType.toLowerCase() == "checkbox" ||
            val.input.elementType == "copyOfInput") &&
          (val.input.elementConfig.type.toLowerCase() == "multiselectt1" ||
            val.input.elementConfig.type.toLowerCase() == "multiselectt2" ||
            val.input.elementConfig.type.toLowerCase() == "multiselectt3" ||
            val.input.elementConfig.type.toLowerCase() == "multiselectt4" ||
            val.input.elementConfig.type.toLowerCase() == "multiselectt5")
        ) {
          //AddedOn:13-12-2021
          console.log("process_multi_checkbox", val.input);

          val.multiSelectValue.forEach((selectedValue) => {
            console.log("process_multi_checkbox_selectedValue", selectedValue);

            if (
              val.input.condition.conditionStatements[selectedValue] !=
              undefined
            ) {
              let keyAddOnTemp = "" + key + 0;
              conditionalFormsFieldsDataSorted = sortFormFields(
                val.input.condition.conditionStatements[selectedValue]
                  .subFormFields.formFields
              );

              conditionalFormsFieldsDataSorted.forEach((formInElement) => {
                let formKeyAddOnTemp =
                  formInElement.elementUId + "" + keyAddOnTemp;
                if (formInElement.isGlobal == true) {
                  formKeyAddOnTemp = formInElement.elementUId; // + addition2key;
                }

                if (formInElement.elementType.toLowerCase() == "label") {
                  formdata[formKeyAddOnTemp] = formInElement.value;
                }

                if (formInElement.elementType == "copyOfInput") {
                  let mainParentFieldKey =
                    formInElement.value + "" + keyAddOnTemp;
                  if (formdata[mainParentFieldKey] != undefined) {
                    const input = document.querySelector(
                      "#" + formKeyAddOnTemp
                    );
                    if (input != null) {
                      // This will work by calling the native setter bypassing Reacts incorrect value change check
                      Object.getOwnPropertyDescriptor(
                        window.HTMLInputElement.prototype,
                        "value"
                      ).set.call(input, formdata[mainParentFieldKey]);
                      // This will trigger a new render wor the component
                      input.dispatchEvent(
                        new Event("change", { bubbles: true })
                      );
                    }
                  }
                }

                if (formInElement.elementType.toLowerCase() == "amount2words") {
                  formdata[formKeyAddOnTemp] = digitAmountToWord(
                    formdata[formInElement.value + "" + keyAddOnTemp]
                  );
                }

                if (formInElement.elementType.toLowerCase() == "formula") {
                  let formulaObject = fetchFormulaObjectForConditionalElementV2(
                    formInElement.value,
                    keyAddOnTemp
                  );
                  var processFormulaObjectValue =
                    processFormulaObjectForConditionalElementV2(
                      formulaObject,
                      formdata,
                      keyAddOnTemp
                    );
                  formdata[formKeyAddOnTemp] = processFormulaObjectValue;
                }

                if (formInElement.elementType.toLowerCase() == "strngformula") {
                  let formulaObject =
                    fetchStringFormulaObjectForConditionalElementV2(
                      formInElement.value,
                      keyAddOnTemp
                    );
                  var processFormulaObjectValue =
                    processStringFormulaObjectForConditionalElementV2(
                      formulaObject,
                      formdata,
                      keyAddOnTemp,
                      formInElement.elementConfig.type.toLowerCase()
                    );
                  formdata[formKeyAddOnTemp] = processFormulaObjectValue;
                }

                if (formInElement.elementType.toLowerCase() == "legalformula") {
                  //DevNote:legalformula//added on 24-02-2024//

                  console.log("mainFormFields", "---- legalformula ----");
                  console.log("mainFormFields_legalformula_key", key);
                  console.log(
                    "mainFormFields_legalformula_val.value",
                    formInElement.value
                  );
                  console.log(
                    "mainFormFieldsformdata[key]_legalformula_" + key,
                    formdata[key]
                  );
                  let stringLegalObject =
                    fetchLegalFormulaObjectForConditionalElement(
                      formInElement.value,
                      keyAddOnTemp
                    );
                  console.log(
                    "mainFormFields_legalformula_formulaObject",
                    stringLegalObject
                  );
                  let processLegalFormulaObjectValue =
                    processLegalFormulaObjectForConditionalElement(
                      stringLegalObject,
                      formdata,
                      keyAddOnTemp,
                      formInElement.elementConfig.type.toLowerCase()
                    );
                  console.log(
                    "mainFormFields_legalformula_processFormulaObjectValue",
                    processLegalFormulaObjectValue
                  );
                  formdata[formKeyAddOnTemp] = processLegalFormulaObjectValue;

                  console.log(
                    "mainFormFields_legalformula_processFormulaObjectValue_key",
                    formdata[formKeyAddOnTemp]
                  );
                }

                if (formInElement.elementType.toLowerCase() == "trigger") {
                  //DevNote:trigger type input//added on 22-02-2024
                  console.log("mainFormFields_trigger_key", key);
                  let triggerKeyValue = processTriggerInputKeyValue(
                    formInElement.value
                  );
                  console.log(
                    "mainFormFields_trigger_triggerKeyValue",
                    triggerKeyValue
                  );
                  formdata[key] = "";

                  if (
                    triggerKeyValue[0] != undefined &&
                    triggerKeyValue[0].length > 0 &&
                    formdata[triggerKeyValue[0] + keyAddOnTemp] != undefined &&
                    formdata[triggerKeyValue[0] + keyAddOnTemp].length > 0
                  ) {
                    console.log(
                      "mainFormFields_trigger_triggerKeyValue_formdata",
                      triggerKeyValue,
                      formdata[triggerKeyValue[0] + keyAddOnTemp]
                    );
                    if (
                      triggerKeyValue[1] != undefined &&
                      triggerKeyValue[1].length > 0
                    ) {
                      formdata[formKeyAddOnTemp] = triggerKeyValue[1];
                    }
                    console.log(
                      "mainFormFields_trigger_key_formdata",
                      key,
                      formdata[formKeyAddOnTemp]
                    );
                  }
                }

                if (formInElement.elementType.toLowerCase() == "checkbox") {
                  if (
                    formInElement.elementConfig.type.toLowerCase() ==
                      "multiselectt1" ||
                    formInElement.elementConfig.type.toLowerCase() ==
                      "multiselectt2" ||
                    formInElement.elementConfig.type.toLowerCase() ==
                      "multiselectt3" ||
                    formInElement.elementConfig.type.toLowerCase() ==
                      "multiselectt4" ||
                    formInElement.elementConfig.type.toLowerCase() ==
                      "multiselectt5"
                  ) {
                    //Do Nothing
                  } else {
                    if (formdata[formKeyAddOnTemp] == undefined) {
                      formdata[formKeyAddOnTemp] = ""; //<- Hold Changes on 25-05-2021
                    } else {
                      if (formdata[formKeyAddOnTemp].length > 0) {
                        formdata[formKeyAddOnTemp] = formInElement.value;
                      } else {
                        //DO Nothing
                      }
                    }
                  }
                }

                conditionalFormsFieldsDataSortedMain[formKeyAddOnTemp] =
                  formInElement;
                console.log(
                  "formFieldObjectFF-formKeyAddOnTemp1",
                  formKeyAddOnTemp
                );
              });
            }
            //----------------------------------------------------
          });
        } else if (
          val.input.elementType.toLowerCase() == "select" ||
          val.input.elementType.toLowerCase() == "radio" ||
          val.input.elementType.toLowerCase() == "datalist" ||
          (val.input.elementType == "copyOfInput" &&
            val.input.condition.conditionType == "ValueBased")
        ) {
          if (
            val.input.condition.conditionStatements[val.inputValue] != undefined
          ) {
            //let keyAddOnTemp = "" + val.input.elementUId + 0;
            let keyAddOnTemp = "" + key + 0;
            conditionalFormsFieldsDataSorted = sortFormFields(
              val.input.condition.conditionStatements[val.inputValue]
                .subFormFields.formFields
            );

            conditionalFormsFieldsDataSorted.forEach((formInElement) => {
              let formKeyAddOnTemp =
                formInElement.elementUId + "" + keyAddOnTemp;
              if (formInElement.isGlobal == true) {
                formKeyAddOnTemp = formInElement.elementUId; // + addition2key;
              }

              if (formInElement.elementType.toLowerCase() == "label") {
                formdata[formKeyAddOnTemp] = formInElement.value;
              }

              if (formInElement.elementType == "copyOfInput") {
                let mainParentFieldKey =
                  formInElement.value + "" + keyAddOnTemp;
                if (formdata[mainParentFieldKey] != undefined) {
                  const input = document.querySelector("#" + formKeyAddOnTemp);
                  if (input != null && input != undefined) {
                    // This will work by calling the native setter bypassing Reacts incorrect value change check
                    Object.getOwnPropertyDescriptor(
                      window.HTMLInputElement.prototype,
                      "value"
                    ).set.call(input, formdata[mainParentFieldKey]);
                    // This will trigger a new render wor the component
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                  }
                }
              }

              if (formInElement.elementType.toLowerCase() == "amount2words") {
                formdata[formKeyAddOnTemp] = digitAmountToWord(
                  formdata[formInElement.value + "" + keyAddOnTemp]
                );
              }

              if (formInElement.elementType.toLowerCase() == "formula") {
                let formulaObject = fetchFormulaObjectForConditionalElementV2(
                  formInElement.value,
                  keyAddOnTemp
                );
                var processFormulaObjectValue =
                  processFormulaObjectForConditionalElementV2(
                    formulaObject,
                    formdata,
                    keyAddOnTemp
                  );
                formdata[formKeyAddOnTemp] = processFormulaObjectValue;
              }

              if (formInElement.elementType.toLowerCase() == "strngformula") {
                let formulaObject =
                  fetchStringFormulaObjectForConditionalElementV2(
                    formInElement.value,
                    keyAddOnTemp
                  );
                let processFormulaObjectValue =
                  processStringFormulaObjectForConditionalElementV2(
                    formulaObject,
                    formdata,
                    keyAddOnTemp,
                    formInElement.elementConfig.type.toLowerCase()
                  );
                formdata[formKeyAddOnTemp] = processFormulaObjectValue;
              }

              if (formInElement.elementType.toLowerCase() == "legalformula") {
                //DevNote:legalformula//added on 24-02-2024//

                console.log("mainFormFields", "---- legalformula ----");
                console.log("mainFormFields_legalformula_key", key);
                console.log(
                  "mainFormFields_legalformula_val.value",
                  formInElement.value
                );
                console.log(
                  "mainFormFieldsformdata[key]_legalformula_" + key,
                  formdata[key]
                );
                let stringLegalObject =
                  fetchLegalFormulaObjectForConditionalElement(
                    formInElement.value,
                    keyAddOnTemp
                  );
                console.log(
                  "mainFormFields_legalformula_formulaObject",
                  stringLegalObject
                );
                let processLegalFormulaObjectValue =
                  processLegalFormulaObjectForConditionalElement(
                    stringLegalObject,
                    formdata,
                    keyAddOnTemp,
                    formInElement.elementConfig.type.toLowerCase()
                  );
                console.log(
                  "mainFormFields_legalformula_processFormulaObjectValue",
                  processLegalFormulaObjectValue
                );
                formdata[formKeyAddOnTemp] = processLegalFormulaObjectValue;

                console.log(
                  "mainFormFields_legalformula_processFormulaObjectValue_key",
                  formdata[formKeyAddOnTemp]
                );
              }

              if (formInElement.elementType.toLowerCase() == "trigger") {
                //DevNote:trigger type input//added on 22-02-2024
                console.log("mainFormFields_trigger_key", key);
                let triggerKeyValue = processTriggerInputKeyValue(
                  formInElement.value
                );
                console.log(
                  "mainFormFields_trigger_triggerKeyValue",
                  triggerKeyValue
                );
                formdata[key] = "";

                if (
                  triggerKeyValue[0] != undefined &&
                  triggerKeyValue[0].length > 0 &&
                  formdata[triggerKeyValue[0] + keyAddOnTemp] != undefined &&
                  formdata[triggerKeyValue[0] + keyAddOnTemp].length > 0
                ) {
                  console.log(
                    "mainFormFields_trigger_triggerKeyValue_formdata",
                    triggerKeyValue,
                    formdata[triggerKeyValue[0] + keyAddOnTemp]
                  );
                  if (
                    triggerKeyValue[1] != undefined &&
                    triggerKeyValue[1].length > 0
                  ) {
                    formdata[formKeyAddOnTemp] = triggerKeyValue[1];
                  }
                  console.log(
                    "mainFormFields_trigger_key_formdata",
                    key,
                    formdata[formKeyAddOnTemp]
                  );
                }
              }

              if (formInElement.elementType.toLowerCase() == "checkbox") {
                if (
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt1" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt2" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt3" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt4" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt5"
                ) {
                  //Do Nothing
                } else {
                  if (formdata[formKeyAddOnTemp] == undefined) {
                    formdata[formKeyAddOnTemp] = "";
                  } else {
                    if (formdata[formKeyAddOnTemp].length > 0) {
                      formdata[formKeyAddOnTemp] = formInElement.value;
                    } else {
                      //DO Nothing
                    }
                  }
                }
              }
              conditionalFormsFieldsDataSortedMain[formKeyAddOnTemp] =
                formInElement;
            });
          } else {
            //DoNothing
          }
        } else {
          //populateCount
          let ifPopulateCount = 1;
          if (isNaN(val.inputValue)) {
            //DoNothing
          } else {
            if (
              (val.input.elementType.toLowerCase() == "input" ||
                val.input.elementType == "copyOfInput") &&
              (val.input.elementConfig.type.toLowerCase() == "number" ||
                val.input.elementConfig.type.toLowerCase() == "daystring" ||
                val.input.elementConfig.type.toLowerCase() == "monthstring")
            ) {
              ifPopulateCount = parseInt(val.inputValue);
            }
          }

          for (var i = 0; i < ifPopulateCount; i++) {
            let keyAddOnTemp = "" + key + i; //DevNoteDate: on 30-03-2021
            conditionalFormsFieldsDataSorted = sortFormFields(
              val.input.condition.subFormFields.formFields
            );

            conditionalFormsFieldsDataSorted.forEach((formInElement) => {
              let formKeyAddOnTemp =
                formInElement.elementUId + "" + keyAddOnTemp;
              if (formInElement.isGlobal == true) {
                formKeyAddOnTemp = formInElement.elementUId; // + addition2key;
              }
              if (formInElement.elementType.toLowerCase() == "label") {
                formdata[formKeyAddOnTemp] = formInElement.value;
              }

              if (formInElement.elementType == "copyOfInput") {
                let mainParentFieldKey =
                  formInElement.value + "" + keyAddOnTemp;
                if (formdata[mainParentFieldKey] != undefined) {
                  const input = document.querySelector("#" + formKeyAddOnTemp);
                  if (input != null && input != undefined) {
                    // This will work by calling the native setter bypassing Reacts incorrect value change check
                    Object.getOwnPropertyDescriptor(
                      window.HTMLInputElement.prototype,
                      "value"
                    ).set.call(input, formdata[mainParentFieldKey]);
                    // This will trigger a new render wor the component
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                  }
                }
              }

              if (formInElement.elementType.toLowerCase() == "amount2words") {
                formdata[formKeyAddOnTemp] = digitAmountToWord(
                  formdata[formInElement.value + "" + keyAddOnTemp]
                );
              }

              if (formInElement.elementType.toLowerCase() == "formula") {
                let formulaObject = fetchFormulaObjectForConditionalElementV2(
                  formInElement.value,
                  keyAddOnTemp
                );
                var processFormulaObjectValue =
                  processFormulaObjectForConditionalElementV2(
                    formulaObject,
                    formdata,
                    keyAddOnTemp
                  );
                formdata[formKeyAddOnTemp] = processFormulaObjectValue;
              }

              if (formInElement.elementType.toLowerCase() == "strngformula") {
                let formulaObject =
                  fetchStringFormulaObjectForConditionalElementV2(
                    formInElement.value,
                    keyAddOnTemp
                  );
                let processFormulaObjectValue =
                  processStringFormulaObjectForConditionalElementV2(
                    formulaObject,
                    formdata,
                    keyAddOnTemp,
                    formInElement.elementConfig.type.toLowerCase()
                  );
                formdata[formKeyAddOnTemp] = processFormulaObjectValue;
              }

              if (formInElement.elementType.toLowerCase() == "legalformula") {
                //DevNote:legalformula//added on 24-02-2024//

                console.log("mainFormFields", "---- legalformula ----");
                console.log("mainFormFields_legalformula_key", key);
                console.log(
                  "mainFormFields_legalformula_val.value",
                  formInElement.value
                );
                console.log(
                  "mainFormFieldsformdata[key]_legalformula_" + key,
                  formdata[key]
                );
                let stringLegalObject =
                  fetchLegalFormulaObjectForConditionalElement(
                    formInElement.value,
                    keyAddOnTemp
                  );
                console.log(
                  "mainFormFields_legalformula_formulaObject",
                  stringLegalObject
                );
                let processLegalFormulaObjectValue =
                  processLegalFormulaObjectForConditionalElement(
                    stringLegalObject,
                    formdata,
                    keyAddOnTemp,
                    formInElement.elementConfig.type.toLowerCase()
                  );
                console.log(
                  "mainFormFields_legalformula_processFormulaObjectValue",
                  processLegalFormulaObjectValue
                );
                formdata[formKeyAddOnTemp] = processLegalFormulaObjectValue;

                console.log(
                  "mainFormFields_legalformula_processFormulaObjectValue_key",
                  formdata[formKeyAddOnTemp]
                );
              }

              if (formInElement.elementType.toLowerCase() == "trigger") {
                //DevNote:trigger type input//added on 22-02-2024
                console.log("mainFormFields_trigger_key", key);
                let triggerKeyValue = processTriggerInputKeyValue(
                  formInElement.value
                );
                console.log(
                  "mainFormFields_trigger_triggerKeyValue",
                  triggerKeyValue
                );
                formdata[key] = "";

                if (
                  triggerKeyValue[0] != undefined &&
                  triggerKeyValue[0].length > 0 &&
                  formdata[triggerKeyValue[0] + keyAddOnTemp] != undefined &&
                  formdata[triggerKeyValue[0] + keyAddOnTemp].length > 0
                ) {
                  console.log(
                    "mainFormFields_trigger_triggerKeyValue_formdata",
                    triggerKeyValue,
                    formdata[triggerKeyValue[0] + keyAddOnTemp]
                  );
                  if (
                    triggerKeyValue[1] != undefined &&
                    triggerKeyValue[1].length > 0
                  ) {
                    formdata[formKeyAddOnTemp] = triggerKeyValue[1];
                  }
                  console.log(
                    "mainFormFields_trigger_key_formdata",
                    key,
                    formdata[formKeyAddOnTemp]
                  );
                }
              }

              if (formInElement.elementType.toLowerCase() == "checkbox") {
                if (
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt1" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt2" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt3" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt4" ||
                  formInElement.elementConfig.type.toLowerCase() ==
                    "multiselectt5"
                ) {
                  //Do Nothing
                } else {
                  if (formdata[formKeyAddOnTemp] == undefined) {
                    formdata[formKeyAddOnTemp] = "";
                  } else {
                    if (formdata[formKeyAddOnTemp].length > 0) {
                      formdata[formKeyAddOnTemp] = formInElement.value;
                    } else {
                      //DO Nothing
                    }
                  }
                }
              }

              conditionalFormsFieldsDataSortedMain[formKeyAddOnTemp] =
                formInElement;
            });
          }
        }
      });
    }

    Object.entries(formdata).map(([key, val]) => {
      let formFieldObject = this.state.mainFormFields[key];
      //no_print
      if (formFieldObject == undefined) {
        formFieldObject = conditionalFormsFieldsDataSortedMain[key];
      }

      if (formFieldObject == undefined) {
        template = template.replace(
          new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
          val
        );
      } else {
        if (formFieldObject.elementType.toLowerCase() == "label") {
          if (formFieldObject.isHidden == true) {
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              "<span className='no_print'>" + val + "</span>"
            );
          } else {
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              val
            );
          }
        } else if (formFieldObject.elementType.toLowerCase() == "textarea") {
          if (formFieldObject.isHidden == true) {
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              ""
            );
          } else {
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              val.replace(new RegExp("\n", "gi"), "<br/>")
            );
          }
        } else if (formFieldObject.elementType.toLowerCase() == "checkbox") {
          //AddedOn: 14-12-2021 to Process MultiSelectCheckBox
          if (
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt1" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt2" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt3" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt4" ||
            formFieldObject.elementConfig.type.toLowerCase() == "multiselectt5"
          ) {
            console.log(
              "tamplevaluereple_val_checkbox",
              val,
              key,
              formFieldObject
            );
            if (formFieldObject.isHidden == true) {
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                ""
              );
            } else {
              //Hidding Template as its Render as per SeletedValues in populateSubConditonalForm() function
              if (formFieldObject.isConditional === true) {
                template = template.replace(
                  new RegExp(
                    inPutFieldStartBlank + key + inPutFieldEndBlank,
                    "gi"
                  ),
                  ""
                );
              } else {
                console.log(
                  "tamplevaluereple_val_checkbox_split",
                  val.split(",")
                );
                template = template.replace(
                  new RegExp(
                    inPutFieldStartBlank + key + inPutFieldEndBlank,
                    "gi"
                  ),
                  val
                );
              }
            }
          } else {
            if (formFieldObject.isHidden == true) {
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                ""
              );
            } else {
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                val
              );
            }
          }
        } else if (formFieldObject.elementType.toLowerCase() == "copyofinput") {
          //Remark[Flow]:18-04-2023 CopyOfMultiSelectValue Process
          if (
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt1" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt2" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt3" ||
            formFieldObject.elementConfig.type.toLowerCase() ==
              "multiselectt4" ||
            formFieldObject.elementConfig.type.toLowerCase() == "multiselectt5"
          ) {
            // console.log("formFieldObject_Multi",formFieldObject)
            // console.log("formFieldObject_Multi_key",key)
            if (formFieldObject.isHidden == true) {
              // console.log("formFieldObject_Multi","is Hidden")
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                ""
              );
              // console.log("formFieldObject_Multi_template",template)
            } else {
              //Hidding Template as its Render as per SeletedValues in populateSubConditonalForm() function
              console.log("formFieldObject_", formFieldObject);
              if (formFieldObject.isConditional === true) {
                template = template.replace(
                  new RegExp(
                    inPutFieldStartBlank + key + inPutFieldEndBlank,
                    "gi"
                  ),
                  ""
                );
              } else {
                template = template.replace(
                  new RegExp(
                    inPutFieldStartBlank + key + inPutFieldEndBlank,
                    "gi"
                  ),
                  val
                );
              }
            }
          } else {
            //console.log("IsHiddenFF",formFieldObject)
            if (formFieldObject.isHidden == true) {
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                ""
              );
            } else {
              template = template.replace(
                new RegExp(
                  inPutFieldStartBlank + key + inPutFieldEndBlank,
                  "gi"
                ),
                val
              );
            }
          }
        } else {
          if (formFieldObject.isHidden == true) {
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              ""
            );
          } else {
            let value2Show = val;

            if (formFieldObject.valueStyle != undefined) {
              if (
                formFieldObject.elementConfig.type.toLowerCase() == "number"
              ) {
                value2Show = rendringInputValueStyle(
                  formFieldObject.valueStyle,
                  val,
                  (formFieldObject.validation.maxLength + "").length + 1
                );
              } else if (
                formFieldObject.elementConfig.type.toLowerCase() == "text"
              ) {
                value2Show = rendringInputValueStyle(
                  formFieldObject.valueStyle,
                  val,
                  formFieldObject.validation.maxLength
                );
              } else {
                if (isNaN(val)) {
                  //i.e. Val is string/text type
                  value2Show = rendringInputValueStyle(
                    formFieldObject.valueStyle,
                    val,
                    formFieldObject.validation.maxLength
                  );
                } else {
                  //is number
                  value2Show = rendringInputValueStyle(
                    formFieldObject.valueStyle,
                    val,
                    (val + "").length
                  );
                }
              }
            }
            console.log("template_value2Show_value2Show", value2Show);
            console.log("template_value2Show_pre_template", template);
            template = template.replace(
              new RegExp(inPutFieldStartBlank + key + inPutFieldEndBlank, "gi"),
              value2Show
            );
            console.log("template_value2Show_", template);
          }
        }
      }
    });

    //DevNote[Flow]:Processing DocForm PreFill
    if (
      this.props.docFormPreFills != null &&
      this.props.docFormPreFills != undefined &&
      this.props.docFormPreFills.length > 0
    ) {
      this.props.docFormPreFills.map((docFormPreFill) => {
        template = template.replace(
          new RegExp(
            inPutFieldStartBlank + docFormPreFill.fieldKey + inPutFieldEndBlank,
            "gi"
          ),
          docFormPreFill?.value
        );
      });
    }

    return template;
  }

  processConditionalFormFieldTemplate(
    mainFormTemplate,
    conditionalFormFieldInput,
    conditionalFormFieldValue,
    templateKey,
    level
  ) {
    let conditionalKeyValueTemplate = [];
    Object.keys(this.state.formData).forEach((key) => {
      let formFieldObject = this.state.mainFormFields[key];
      let templateKeyTemp = ""; //formFieldObject.elementUId
      let multiSelectedValue = [];

      if (formFieldObject == undefined) {
        if (this.state.conditionalFormInputs[key] != undefined) {
          formFieldObject = this.state.conditionalFormInputs[key].input;
          templateKeyTemp = this.state.conditionalFormInputs[key].templateKey;
        }
      } else {
        templateKeyTemp = formFieldObject.elementUId;
      }

      //AddedOn: 14-12-2021 to Process MultiSelectedCheckBox
      if (
        formFieldObject != undefined &&
        (formFieldObject.elementType.toLowerCase() == "checkbox" ||
          formFieldObject.elementType.toLowerCase() == "copyofinput") &&
        (formFieldObject.elementConfig.type.toLowerCase() == "multiselectt1" ||
          formFieldObject.elementConfig.type.toLowerCase() == "multiselectt2" ||
          formFieldObject.elementConfig.type.toLowerCase() == "multiselectt3" ||
          formFieldObject.elementConfig.type.toLowerCase() == "multiselectt4" ||
          formFieldObject.elementConfig.type.toLowerCase() == "multiselectt5")
      ) {
        if (
          this.state.conditionalFormInputs[key] != undefined &&
          this.state.conditionalFormInputs[key].multiSelectValue != undefined
        ) {
          multiSelectedValue =
            this.state.conditionalFormInputs[key].multiSelectValue;
        }
      }

      let formFieldValue = this.state.formData[key];

      if (
        formFieldObject != undefined &&
        formFieldObject.isConditional == true
      ) {
        let populateCountTemp = 0;
        if (formFieldValue.length > 0) {
          populateCountTemp = 1;
          if (isNaN(formFieldValue)) {
          } else {
            //Populate Only if data is Number
            if (
              (formFieldObject.elementType.toLowerCase() == "input" ||
                formFieldObject.elementType == "copyOfInput") &&
              (formFieldObject.elementConfig.type.toLowerCase() == "number" ||
                formFieldObject.elementConfig.type.toLowerCase() ==
                  "daystring" ||
                formFieldObject.elementConfig.type.toLowerCase() ==
                  "monthstring")
            ) {
              populateCountTemp = parseInt(formFieldValue);
            }
          }
        }

        let conditonalTemplate = "";
        console.log("populateCountTemp_1733: ", populateCountTemp);
        console.log("formFieldValue_1816: ", formFieldValue);
        console.log("formFieldObject_1817: ", formFieldObject);
        console.log("templateKeyTemp_1818: ", templateKeyTemp);

        if (populateCountTemp > 0) {
          const value = populateSubConditonalForm(
            formFieldObject,
            populateCountTemp,
            formFieldValue,
            templateKeyTemp,
            multiSelectedValue
          );
          conditonalTemplate = value.rows;
          console.log(
            "removableKeysFormData_1829: ",
            value.removableKeysFormData
          );
          if (value.removableKeysFormData.size > 0) {
            // this.state.formData.
            value.removableKeysFormData.forEach((each) => {
              console.log("each_1838: ", each);
              // this.state.formData.delete(each);
            });
          }
          resetRemovableKeysFormData();
          // conditonalTemplate = populateSubConditonalForm(
          //   formFieldObject,
          //   populateCountTemp,
          //   formFieldValue,
          //   templateKeyTemp,
          //   multiSelectedValue
          // );
        }
        console.log("conditonalTemplate_on_main", conditonalTemplate);
        console.log("templateKeyTemp_1856", templateKeyTemp);
        //Old
        conditionalKeyValueTemplate[templateKeyTemp] = conditonalTemplate;
        //New
        // conditionalKeyValueTemplate[
        //   templateKey
        // ] = conditonalTemplate;
      } else {
        //DoNothing
      }
    });

    console.log("mainFormTemplate_1827: ", mainFormTemplate);
    console.log(
      "conditionalKeyValueTemplate_1828: ",
      conditionalKeyValueTemplate
    );

    if (Object.keys(conditionalKeyValueTemplate).length > 0) {
      console.log("__1757__");
      let testMainTemplateTemp2 = replaceTemplateKeyWithFormDataViewTTV2(
        mainFormTemplate,
        conditionalKeyValueTemplate
      );
      this.setState({ mainDocFormTemplate: testMainTemplateTemp2 });
      console.log("testMainTemplateTemp2_1850: ", testMainTemplateTemp2);
    } else {
      let populateCount = 0;
      if (conditionalFormFieldValue?.length > 0) {
        populateCount = 1;
        if (isNaN(conditionalFormFieldValue)) {
        } else {
          //conditionalFormFieldInput
          if (
            (conditionalFormFieldInput.elementType.toLowerCase() == "input" ||
              conditionalFormFieldInput.elementType == "copyOfInput") &&
            (conditionalFormFieldInput.elementConfig.type.toLowerCase() ==
              "number" ||
              conditionalFormFieldInput.elementConfig.type.toLowerCase() ==
                "daystring" ||
              conditionalFormFieldInput.elementConfig.type.toLowerCase() ==
                "monthstring")
          ) {
            populateCount = parseInt(conditionalFormFieldValue);
          }
        }
      }

      console.log("populateCount_on_main", populateCount);
      let testTemplate = "";
      if (populateCount > 0) {
        const value = populateSubConditonalForm(
          conditionalFormFieldInput,
          populateCount,
          conditionalFormFieldValue,
          templateKey
        );
        testTemplate = value.rows;
        // testTemplate = populateSubConditonalForm(
        //   conditionalFormFieldInput,
        //   populateCount,
        //   conditionalFormFieldValue,
        //   templateKey
        // );
      }

      console.log("testTemplate_on_main", testTemplate);
      //console.log("formsTemplate", this.props.formsTemplate);
      console.log("mainFormTemplate_on_main", mainFormTemplate);
      let testMainTemplate = replaceTemplateKeyWithFormDataViewTT(
        mainFormTemplate,
        conditionalFormFieldInput.elementUId,
        testTemplate
      );
      console.log("testMainTemplate_On_main", testMainTemplate);
      this.setState({ mainDocFormTemplate: testMainTemplate });
    }
  }

  // emailOrDownloadThisDoc(option) {
  //   //option:0==download PDF
  //   //option:-1==download WORD
  //   //option:1==Print
  //   //option:else email

  //   //filledDocFOrm
  //   console.log("-emailThisDoc-");
  //   //console.log("-emailThisDoc-componentRef", this.componentRef)
  //   //console.log("-emailThisDoc-componentRef_querySelector", this.componentRef.querySelector("#filledDocFOrm"))
  //   let content2Print = this.componentRef;
  //   const targetComponent2Print = content2Print.current || content2Print;
  //   //document.querySelector("#filledDocFOrm")
  //   //console.log("-emailThisDoc_targetComponent2Print",targetComponent2Print)
  //   /*
  //     "@media print { body { -webkit-print-color-adjust: exact; }
  //     @page { size: "+this.state.pageType+";
  //     margin: "+this.state.printMarginTop+"mm "
  //     +this.state.printMarginRight+"mm "
  //     +this.state.printMarginBottom+"mm "
  //     +this.state.printMarginLeft+"mm!important }}"
  //     */
  //   // margin [top, left, bottom, right]
  //   //margin: [Number(this.state.printMarginTop), Number(this.state.printMarginLeft), Number(this.state.printMarginBottom), Number(this.state.printMarginRight)],
  //   //format One of 'a3', 'a4' (Default),'a5' ,'letter' ,'legal'
  //   //margin: [1, 1, 1, 1],
  //   let pageTypeFormat = "a4";
  //   //let pageWidth=
  //   //A4 - 8.3 x 11.7 in
  //   //Legal - 8.5 x 14 in
  //   //Letter - 8.5 x 11 in
  //   //ForA4
  //   let pagesWidth = "8.3in"; //In Inches
  //   let pagesHeight = "11.7in"; //In Inches
  //   if (
  //     this.state.mainFormFields.pageType != undefined &&
  //     this.state.mainFormFields.pageType.length > 1
  //   ) {
  //     pageTypeFormat = this.state.mainFormFields.pageType;
  //   }

  //   if (pageTypeFormat.toLowerCase() == "letter") {
  //     pagesWidth = "8.5in"; //In Inches
  //     pagesHeight = "11.0in"; //In Inches
  //   }
  //   if (pageTypeFormat.toLowerCase() == "legal") {
  //     pagesWidth = "8.5in"; //In Inches
  //     pagesHeight = "14.0in"; //In Inches
  //   }

  //   //in CM
  //   //Default Top:2
  //   //Default Bottom:2
  //   //Default Right:4
  //   //Default Left:4

  //   let setPrintMarginTopVar = 2;
  //   if (!isNaN(this.state.mainFormFields.printMarginTop)) {
  //     setPrintMarginTopVar = Number(this.state.mainFormFields.printMarginTop);
  //   }

  //   let setPrintMarginLeftVar = 4;
  //   if (!isNaN(this.state.mainFormFields.printMarginLeft)) {
  //     setPrintMarginLeftVar = Number(this.state.mainFormFields.printMarginLeft);
  //   }

  //   let setPrintMarginBottomVar = 2;
  //   if (!isNaN(this.state.mainFormFields.printMarginBottom)) {
  //     setPrintMarginBottomVar = Number(
  //       this.state.mainFormFields.printMarginBottom
  //     );
  //   }

  //   let setPrintMarginRightVar = 4;
  //   if (!isNaN(this.state.mainFormFields.printMarginRight)) {
  //     setPrintMarginRightVar = Number(
  //       this.state.mainFormFields.printMarginRight
  //     );
  //   }

  //   let opt = {
  //     margin: [
  //       setPrintMarginTopVar,
  //       setPrintMarginLeftVar,
  //       setPrintMarginBottomVar,
  //       setPrintMarginRightVar,
  //     ],
  //     filename: "docmaster_testrun_" + Date.now() + "_.pdf",
  //     image: { type: "jpeg", quality: 0.96 },
  //     html2canvas: { scale: 2, letterRendering: true },
  //     jsPDF: {
  //       unit: "pt",
  //       format: pageTypeFormat,
  //       orientation: "portrait",
  //       precision: 16,
  //       putOnlyUsedFonts: true,
  //       compress: true,
  //     },
  //   };
  //   console.log("ToPrint_", opt);

  //   //console.log("userData", userData);

  //   // var superThis = this;
  //   if (option == -1) {
  //     //Download Word

  //     let marginStye =
  //       "margin-right: " +
  //       setPrintMarginRightVar * 0.3937 +
  //       "in" +
  //       "; margin-left: " +
  //       setPrintMarginLeftVar * 0.3937 +
  //       "in" +
  //       "; margin-top: " +
  //       setPrintMarginTopVar * 0.3937 +
  //       "in" +
  //       "; margin-bottm: " +
  //       setPrintMarginBottomVar * 0.3937 +
  //       "in" +
  //       ";";

  //     let otherStye =
  //       "<style> @page{ size:" +
  //       pagesWidth +
  //       " " +
  //       pagesHeight +
  //       ";" +
  //       marginStye +
  //       " padding-left: 0pt; padding-right: 0pt; padding-top: 0pt; padding-bottom: 0pt; } </style>";

  //     let header =
  //       "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
  //       "xmlns:w='urn:schemas-microsoft-com:office:word' " +
  //       "xmlns='http://www.w3.org/TR/REC-html40'>" +
  //       "<head><meta charset='utf-8'><title>Export to Word Document</title>" +
  //       otherStye +
  //       "</head><body>";
  //     let footer = "</body></html>";
  //     //var htmlString=header+"<p>Hello World</p>"+footer//document.getElementById("contentToPrint").innerHTML

  //     let htmlString =
  //       header +
  //       processPageBreakForDoc(targetComponent2Print.innerHTML) +
  //       footer;
  //     //document.getElementById("contentToPrint").innerHTML
  //     console.log("htmlString_", htmlString);

  //     let source =
  //       "data:application/vnd.ms-word;charset=utf-8," +
  //       encodeURIComponent(htmlString);
  //     let fileDownload = document.createElement("a");
  //     document.body.appendChild(fileDownload);
  //     fileDownload.href = source;
  //     fileDownload.download = "MyDocMaster_TestRun_" + Date.now() + "_.doc";
  //     fileDownload.click();
  //     document.body.removeChild(fileDownload);

  //     //processPageBreakForDoc
  //   } else if (option == 0) {
  //     //Download PDF
  //     /*
  //      console.log("filename_margin",{
  //       top: setPrintMarginTop + " cm",
  //       left: setPrintMarginLeft + " cm",
  //       right: setPrintMarginRight + " cm",
  //       bottom: setPrintMarginBottom + " cm",
  //     })
  //     */
  //     //console.log("filename_pageTypeFormat",pageTypeFormat)
  //     savePDF(targetComponent2Print, {
  //       forcePageBreak: ".pageBreakCode",
  //       scale: 0.76,
  //       paperSize: pageTypeFormat,
  //       fileName: "docmaster_testrun_" + Date.now() + "_.pdf",
  //       margin: {
  //         top: setPrintMarginTopVar + "cm",
  //         left: setPrintMarginLeftVar + "cm",
  //         right: setPrintMarginRightVar + "cm",
  //         bottom: setPrintMarginBottomVar + "cm",
  //       },
  //     });
  //   } else if (option == 1) {
  //     //print
  //     // let tableStyle =" table{border: inherit;} table,tr{border: inherit;} table,tr,td{border: inherit;}";
  //     let tableStyle =
  //       "table{border:inherit;}" + "table,tr{}" + "table,tr,td{}";
  //     let marginStye =
  //       "margin-right: " +
  //       setPrintMarginRightVar * 0.3937 +
  //       "in" +
  //       "; margin-left: " +
  //       setPrintMarginLeftVar * 0.3937 +
  //       "in" +
  //       "; margin-top: " +
  //       setPrintMarginTopVar * 0.3937 +
  //       "in" +
  //       "; margin-bottm: " +
  //       setPrintMarginBottomVar * 0.3937 +
  //       "in" +
  //       ";";

  //     let otherStye =
  //       "<style> @page{ size:" +
  //       pagesWidth +
  //       " " +
  //       pagesHeight +
  //       ";" +
  //       marginStye +
  //       " padding-left: 0pt; padding-right: 0pt; padding-top: 0pt; padding-bottom: 0pt; } " +
  //       tableStyle +
  //       "</style>";

  //     let header =
  //       "<html>" + "<head><meta charset='utf-8'>" + otherStye + "</head><body>";
  //     let footer = "</body></html>";

  //     let htmlString =
  //       header +
  //       processPageBreakForJsPrint(targetComponent2Print.innerHTML) +
  //       footer;
  //     //document.getElementById("contentToPrint").innerHTML
  //     console.log("htmlString_", htmlString);
  //     htmlString2Print(htmlString); //Done on 20-12-2021
  //   } else {
  //   }
  // }

  emailOrDownloadThisDoc(option, isSubmitted) {
    //option 0: download (after confirmed checkDocFormsLimit to process)
    //Option 5: Download(after checkDocFormsLimit)
    //Option 6: SubmitConfirmation

    if (
      // this.state.userData != undefined &&
      // this.state.userData.mobile_no != undefined
      this.state.userData != undefined
    ) {
      if (option == 0) {
        //Download
        this.sendDocToUser(0, isSubmitted);
        //this.checkDocFormsLimit(1);
      } else if (option == 6) {
        //SubmitConfirmation
        this.sendDocToUser(option, isSubmitted);
      }
      //ToDo: call here print and download confim
    } else {
      const win = window.open("/customerlogin", "_blank");
      win.focus();
    }
  }

  sendDocToUser(option, isSubmitted) {
    // const userDataThis = reactLocalStorage.getObject("user_data");

    //option -1: download word (after confirmed checkDocFormsLimit to process)
    //option 0: download (after confirmed checkDocFormsLimit to process)
    //Option 6: SubmitConfirmation
    const content2Print = this.componentRef;
    const targetComponent2Print = content2Print.current || content2Print;
    //document.querySelector("#filledDocFOrm")
    // console.log("targetComponent2Print_", targetComponent2Print);
    //margin: [1, 1, 1, 1],//Old
    //html2canvas: { scale: 2, dpi: 192, letterRendering: true },Old
    //jsPDF: { unit: "mm", format: "letter", orientation: "portrait" }, //Old
    //console.log("this.state.printMarginLeft",this.state.printMarginLeft)
    var pagesWidth = "8.3in"; //In Inches
    var pagesHeight = "11.7in"; //In Inches

    var pageTypeFormat = "a4";
    if (this.state.pageType != undefined && this.state.pageType.length > 1) {
      pageTypeFormat = this.state.pageType;
    }

    if (pageTypeFormat.toLowerCase() == "letter") {
      pagesWidth = "8.5in"; //In Inches
      pagesHeight = "11.0in"; //In Inches
    }
    if (pageTypeFormat.toLowerCase() == "legal") {
      pagesWidth = "8.5in"; //In Inches
      pagesHeight = "14.0in"; //In Inches
    }

    //Default Top:1
    //Default Bottom:1
    //Default Right:2
    //Default Left:2

    var setPrintMarginTop = 2;
    if (!isNaN(this.state.printMarginTop)) {
      setPrintMarginTop = Number(this.state.printMarginTop);
    }

    var setPrintMarginLeft = 4;
    if (!isNaN(this.state.printMarginLeft)) {
      setPrintMarginLeft = Number(this.state.printMarginLeft);
    }

    var setPrintMarginBottom = 2;
    if (!isNaN(this.state.printMarginBottom)) {
      setPrintMarginBottom = Number(this.state.printMarginBottom);
    }

    var setPrintMarginRight = 4;
    if (!isNaN(this.state.printMarginRight)) {
      setPrintMarginRight = Number(this.state.printMarginRight);
    }

    console.log("setPrintMarginRight_", setPrintMarginRight);
    let fileName2Process = this.props.title + "Mydocmaster_" + Date.now();

    if (option == -1) {
      //Download Word

      let marginStye =
        "margin-right: " +
        setPrintMarginRight * 0.3937 +
        "in" +
        "; margin-left: " +
        setPrintMarginLeft * 0.3937 +
        "in" +
        "; margin-top: " +
        setPrintMarginTop * 0.3937 +
        "in" +
        "; margin-bottm: " +
        setPrintMarginBottom * 0.3937 +
        "in" +
        ";";

      let otherStye =
        "<style> @page{ size:" +
        pagesWidth +
        " " +
        pagesHeight +
        ";" +
        marginStye +
        " padding-left: 0pt; padding-right: 0pt; padding-top: 0pt; padding-bottom: 0pt; } </style>";

      var header =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'>" +
        "<head><meta charset='utf-8'><title>" +
        fileName2Process +
        "</title>" +
        otherStye +
        "</head><body>";
      var footer = "</body></html>";
      let htmlString =
        header +
        processPageBreakForDoc(targetComponent2Print.innerHTML) +
        footer;
      // document.getElementById("contentToPrint").innerHTML
      // console.log("htmlString_", htmlString);

      var source =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(htmlString);
      var fileDownload = document.createElement("a");
      document.body.appendChild(fileDownload);
      fileDownload.href = source;
      fileDownload.download = fileName2Process + ".doc";
      fileDownload.click();
      document.body.removeChild(fileDownload);

      //processPageBreakForDoc
    } else if (option == 4) {
      //To Print
      let marginStye =
        "margin-right: " +
        setPrintMarginRight * 0.3937 +
        "in" +
        "; margin-left: " +
        setPrintMarginLeft * 0.3937 +
        "in" +
        "; margin-top: " +
        setPrintMarginTop * 0.3937 +
        "in" +
        "; margin-bottm: " +
        setPrintMarginBottom * 0.3937 +
        "in" +
        ";";

      let otherStye =
        "<style> @page{ size:" +
        pagesWidth +
        " " +
        pagesHeight +
        ";" +
        marginStye +
        " padding-left: 0pt; padding-right: 0pt; padding-top: 0pt; padding-bottom: 0pt; } </style>";

      var header = "<html>" + "<head>" + otherStye + "</head><body>";
      var footer = "</body></html>";
      //var htmlString=header+"<p>Hello World</p>"+footer//document.getElementById("contentToPrint").innerHTML

      let htmlString =
        header +
        processPageBreakForJsPrint(targetComponent2Print.innerHTML) +
        footer;
      //document.getElementById("contentToPrint").innerHTML
      // console.log("htmlString_", htmlString);
      // this.html2Print(targetComponent2Print);//Done on 20-12-2021
      htmlString2Print(htmlString); //Done on 20-12-2021 //For Version 3
    } else {
      let html2String = processPageBreakForBackEnd(
        this.state.testTemplateToShow
      );

      if (option == 6) {
        this.processSubmitConfirmationForOrgDoc(html2String, isSubmitted);
      }
    }
  }

  processSubmitConfirmationForOrgDoc(htmlString, isSubmitted) {
    toast.success("Verifying...", { autoClose: 50 });

    let title2save =
      this.state.title != undefined && this.state.title?.length > 0
        ? this.state.title
        : this.props.title;
    // console.log("this.state.draft", this.state.draft);
    let formData2Post = new FormData();
    formData2Post.append("userId", this.state.userData.id); //DevNote[Remark]:User Who have or will Submitted Record
    formData2Post.append("docFormId", this.state.formId);
    formData2Post.append("htmlString", htmlString);
    formData2Post.append("inputData", JSON.stringify(this.state.formData));

    formData2Post.append("saveDataOnServer", Number(1));
    formData2Post.append("fromDeviceType", "Web");

    formData2Post.append("submitted", isSubmitted); //DevNote[Remarks] ToDo:Added On: 13-08-2022
    formData2Post.append(
      "recordId",
      this.state.draft?.id > 0 ? this.state.draft?.id : 0
    ); //DevNote[Remarks] ToBeDone:Added On: 13-08-2022

    formData2Post.append("title", title2save); //DevNote[Remarks] ToBeDone:Added On: 13-08-2022
    formData2Post.append("submittedById", this.state.userData.id); //DevNote[Remark]:This will always be current User
    // console.log("PutOrgDocFormUserData_recordId", this.state.draft?.id > 0 ? this.state.draft?.id : 0);
    // console.log("PutOrgDocFormUserData_formData",formData);
    // console.log("PutOrgDocFormUserData_isSubmitted",isSubmitted);

    axios
      .post(WSPutOrgDocFormUserInputData2, formData2Post, {
        headers: apiKeyHeaderMultiPartFormData(),
      })
      .then((response) => {
        const responseData = response.data;
        console.log("PutOrgDocFormUserData_responseData", responseData);
        if (responseData.result_code == 1) {
          this.setState({
            errors: "",
            additionalMessage: responseData.additional_message,
          });

          //id:,title:,inputData:,htmlString:
          if (this.state.draft?.id > 0) {
          } else {
            //id:,title:,inputData:,htmlString:---------
            //,inputData:this.state.formData,htmlString:htmlString
            // console.log("PutOrgDocFormUserData_SetDraft", {id:responseData.recordId,title:title2save});
            this.setState({
              draft: { id: responseData.recordId, title: title2save },
            });
          }

          if (isSubmitted == 0) {
            console.log("2692");
            alert("Document Saved as Draft");
            if (this.props.isOrgAccess == 3) {
              console.log("2694");
              this.props.navigate("/DocFormDraft/1");
            }
          }

          if (isSubmitted > 0) {
            this.setShowActionButtons(true);
            if (this.props?.toMerge) {
              if (this.props.onReturnDraftRecord != undefined) {
                this.props.onReturnDraftRecord({
                  id: responseData.recordId,
                  title: title2save,
                });
              }
            }
          }
        } else {
          window.alert(responseData.result_message);
          this.setState({ errors: responseData.result_message });
        }
      })
      .catch((error) => {
        console.error("PutOrgDocFormUserData_error", error);
      });
  }

  handleAutoFillData(e) {
    e.preventDefault();
    this.setState({
      displayAutoFillPopup: true,
    });
  }

  resetBills() {
    this.setState((prev) => ({ ...prev, seletedBills: [], seletedBill: {} }));
  }

  closeAutoFillPopup() {
    this.setState({
      displayAutoFillPopup: false,
    });
  }

  handleAddAutoFillData(type, details, keys = null) {
    console.log("type_2115: ", type);
    console.log("details_2116:  ", details);

    if (type === "Single") {
      this.setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          [`${details.keys.officeNameKey}${details.keys.prefix}types00`]:
            details.data.name,
          [`${details.keys.numberKey}${details.keys.prefix}types00`]:
            details.data.number,
        },
        seletedBill: details,
        displayAutoFillPopup: false,
      }));
    }

    if (type === "console") {
      this.setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          c_officetypes0: details.name,
          e_metertypes0: details.number,
        },
        seletedBill: details,
        displayAutoFillPopup: false,
      }));
    }

    if (type === "Multiple") {
      this.handleMultipleAutoFillData(
        details,
        keys.multipleKey,
        keys.numberKey,
        keys.officeNameKey
      );
    }
    // if (this.state.formData.types === "Fuel Bill") {
    //   this.handlepetroldata(details, "pum_totaltypes0", "f_num", "f_name");
    // }
  }

  handleMultipleAutoFillData(details, templateKey, numkey, nKey) {
    details.sort((a, b) => a.index - b.index);
    const num = Number(this.state.formData[templateKey]);

    for (let index = 0; index < num; index++) {
      const eachName = details[index] ? details[index].details.name : "";
      const eachNumber = details[index]
        ? String(details[index].details.number)
        : "";
      const customIndex = index;
      const numberKey = numkey + templateKey + customIndex;
      const nameKey = nKey + templateKey + customIndex;

      this.setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          [numberKey]: eachNumber,
          [nameKey]: eachName,
        },
      }));
    }
    this.setState((prev) => ({
      ...prev,
      seletedBills: details,
      displayAutoFillPopup: false,
    }));
  }

  // handlepetroldata(details, templateKey, numkey, nKey) {
  //   details.sort((a, b) => a.index - b.index);

  //   const num =
  //     this.state.formData.pum_totaltypes0?.length > 0
  //       ? Number(this.state.formData.pum_totaltypes0)
  //       : Number(this.state.formData.numberelectricityexpenses00);

  //   for (let index = 0; index < num; index++) {
  //     const eachName = details[index] ? details[index].details.name : "";
  //     const eachNumber = details[index]
  //       ? String(details[index].details.number)
  //       : "";

  //     const customIndex = index;
  //     const numberKey = numkey + templateKey + customIndex;
  //     const nameKey = nKey + templateKey + customIndex;

  //     this.setState((prev) => ({
  //       ...prev,
  //       formData: {
  //         ...prev.formData,
  //         [numberKey]: eachNumber,
  //         [nameKey]: eachName,
  //       },
  //     }));
  //   }
  // }

  getHallDetails(
    selectedHallData,
    includeWaterRate,
    includeStandingLightRate,
    includeAcRate,
    includeOpenAreaRate,
    includeMountingRate
  ) {
    const areaElement = document.getElementById("area_in_sq_ft");
    const exhibitionRateEl = document.getElementById("exhibition_rate");
    const mountingRateEl = document.getElementById("mounting_rate");
    const standingLightRateEl = document.getElementById("standing_light_rate");
    const waterRateEl = document.getElementById("water_rate");
    const acRateEl = document.getElementById("ac_rate");
    const openArea = document.getElementById("open_area_sft");
    const openRate = document.getElementById("open_rate");
    const inputElement = document.getElementById("rental_exhibition_hall");

    if (inputElement) {
      setTimeout(() => {
        // Set the new value
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          "value"
        ).set;

        if (nativeInputValueSetter) {
          nativeInputValueSetter.call(inputElement, selectedHallData.hall_name); // Set value
        }

        // Create and dispatch 'input' and 'change' events to trigger React onChange
        const inputEvent = new Event("input", { bubbles: true });
        inputElement.dispatchEvent(inputEvent);

        const changeEvent = new Event("change", { bubbles: true });
        inputElement.dispatchEvent(changeEvent);
      }, 0);
    }

    const x = includeMountingRate ? selectedHallData.mounting_rate : 0;
    const y = includeMountingRate ? selectedHallData.peak_mounting_rate : 0;

    if (!includeMountingRate) {
      const table5Dropdownel = document.getElementById("table5_values");

      setTimeout(() => {
        table5Dropdownel.value = "all not";
        const inputEvent = new Event("input", { bubbles: true });
        table5Dropdownel.dispatchEvent(inputEvent);
        const changeEvent = new Event("change", { bubbles: true });
        table5Dropdownel.dispatchEvent(changeEvent);
      }, 0);
    } else {
      const table5Dropdownel = document.getElementById("table5_values");

      setTimeout(() => {
        table5Dropdownel.value = "all";
        const inputEvent = new Event("input", { bubbles: true });
        table5Dropdownel.dispatchEvent(inputEvent);
        const changeEvent = new Event("change", { bubbles: true });
        table5Dropdownel.dispatchEvent(changeEvent);
      }, 0);
    }

    const startDate = moment(this.state.formData.start_date, "DD-MM-YYYY");
    const isMarchToAugust = startDate.month() >= 2 && startDate.month() <= 7;

    this.createNumberEvent(areaElement, selectedHallData.area);
    this.createNumberEvent(
      exhibitionRateEl,
      isMarchToAugust
        ? selectedHallData.exhibition_rate
        : selectedHallData.peak_exhibition_rate
    );
    this.createNumberEvent(
      mountingRateEl,
      includeMountingRate
        ? isMarchToAugust
          ? // ? selectedHallData.mounting_rate
            // : selectedHallData.peak_mounting_rate
            x
          : y
        : 0
    );
    this.createNumberEvent(
      standingLightRateEl,
      includeStandingLightRate ? selectedHallData.standing_light_rate : 0
    );
    this.createNumberEvent(
      waterRateEl,
      includeWaterRate ? selectedHallData.water_rate : 0
    );
    this.createNumberEvent(
      acRateEl,
      includeAcRate ? selectedHallData.ac_rate : 0
    );
    this.createNumberEvent(openArea, selectedHallData.open_area);
    this.createNumberEvent(
      openRate,
      includeOpenAreaRate
        ? isMarchToAugust
          ? selectedHallData.lean_open_area_rate
          : selectedHallData.peak_open_area_rate
        : 0
    );
  }

  createNumberEvent(element, value) {
    if (element) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      ).set;

      if (nativeInputValueSetter) {
        nativeInputValueSetter.call(element, `${value}`);
      }

      setTimeout(() => {
        const inputEvent = new InputEvent("input", {
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(inputEvent);

        // Dispatch change event (sometimes required for React)
        const changeEvent = new Event("change", { bubbles: true });
        element.dispatchEvent(changeEvent);
      }, 0);
    }
  }

  handleSubmitData(e) {
    e.preventDefault();
    const formHTML = document.getElementById("contentToPrintInner").innerHTML;
    const payload = {
      userId: this.userData.id,
      // orgId: this.userData.org.id,
      formId: this.formId,
      htmlData: formHTML,
    };

    axios
      .post(addDocFormData, payload, { headers: apiKeyHeader() })
      .then((response) => {
        console.log("Success:", response.data);
        alert("Form Submitted successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      });
  }

  //   saveDocFormDraft() {
  //     // if (this.props.isOrgAccess == 1) {
  //     //   this.emailOrDownloadThisDoc(6, 0);
  //     // }
  // this.props.dispatch(GetUserAccessThunk());
  //     // if (this.props.isOrgAccess == 1 || this.props.isOrgAccess == 3) {
  //     this.emailOrDownloadThisDoc(6, 0);
  //     // }
  //   }
  async saveDocFormDraft() {
    // if (
    //   this.props.userData.roles === "trial" &&
    //   this.props.userAccessData?.total_records >=
    //     this.props.userCountRestrictions?.demo?.documents
    // ) {
    //   return alert(
    //     `You are in a trial period and can create only ${this.props.userCountRestrictions.demo.documents} documents.`
    //   );
    // }

    this.emailOrDownloadThisDoc(6, 0);
  }

  submitEventData = (selectedEvent, selectedActivity) => {
    console.log("selectedEvent", selectedEvent);
    console.log("selectedActivity", selectedActivity);

    const docData = document.getElementById("contentToPrint").innerHTML;

    const payload = {
      form_id: this.formId,
      event_id: selectedEvent.id,
      activity_id: selectedActivity.id,
      form_data: docData,
      form_name: this.props.title || "",
    };

    const userId = this.userData.id;
    // const orgId = this.userData.org.id;

    // fetch(`${AddEventDocForm}/${userId}/${orgId}`, {
    fetch(`${AddEventDocForm}/${userId}`, {
      method: "POST",
      headers: apiKeyHeader(),
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.status === 201) {
          return res.json().then((data) => {
            console.log("Response from server:", data);
            alert("Form saved successfully!");
            this.confirmSubmittedForm();

            this.props.dispatch(
              GetActivityDetailsThunk({ activityId: selectedActivity.id })
            );
            this.props.navigate("/activity-details", {
              state: {
                eventId: selectedEvent.id,
                activityId: selectedActivity.id,
              },
            });
            // selectedEvent.id, selectedActivity.id
            // if (this.state.activityId && this.state.eventId) {
            //   //
            // } else {
            //   this.props.navigate("/myDocForms");
            // }
          });
        }
        throw new Error(`Unexpected response status: ${res.status}`);
      })
      .catch((err) => {
        console.error("Error submitting data:", err);
        alert("Error saving form!");
      });
  };

  onFormSubmit = async (e) => {
    e.preventDefault();

    // if (
    //   this.props.userData.roles === "trial" &&
    //   this.props.userAccessData?.total_records >=
    //     this.props.userCountRestrictions?.demo?.documents
    // ) {
    //   return alert(
    //     `You are in a trial period and can create only ${this.props.userCountRestrictions.demo.documents} documents.`
    //   );
    // }

    // if (this.props.isOrgAccess == 3) {
    // if (this.state.eventId && this.state.activityId) {
    //   this.submitEventData(
    //     { id: this.state.eventId },
    //     { id: this.state.activityId }
    //   );
    //   // await this.submitEventData(
    //   //   this.state.eventId,
    //   //   this.state.activityId
    //   // );
    //   return;
    // }
    // const confirmProceed = window.confirm("Do you want to link with Event?");
    // if (confirmProceed) {
    //   console.log("confirms");
    //   this.setState({ showEvents: true });
    //   await this.props.dispatch(
    //     fetchOrganiserEvents({
    //       userId: this.userData.id,
    //       // orgId: this.userData.org.id,
    //     })
    //   );
    //   // const { eventId, activityId } = this.state;
    //   // console.log("Checking event/activity IDs:", eventId, activityId);
    // } else {
    //   document.querySelector("#docFormInputFields").classList.add("none");
    //   document.querySelector("#editDocFormDiv").classList.add("none");
    //   document.querySelector("#actionsButtons").classList.remove("none");
    //   document.getElementById("docFormPreview").classList.add("width-78");
    // }
    // return;
    // }
    if (!this.props.isOrgAccess == 1) return;
    //Handling UI Transitions
    document.querySelector("#docFormInputFields").classList.add("none");
    document.querySelector("#editDocFormDiv").classList.add("none");

    document.querySelector("#actionsButtons").classList.remove("none");
    document.getElementById("docFormPreview").classList.add("width-78");

    // document
    //   .getElementById("TemplateToggle")
    //   .classList.add("HideTemplateToggleButton");
  };

  confirmSubmittedForm() {
    this.emailOrDownloadThisDoc(6, 1); //main flow
    let confirmButton = document.getElementById("confirmButton");
    setTimeout(() => {
      confirmButton.disabled = false;
    }, 10000);
  }

  setShowActionButtons(option) {
    if (option) {
      this.setState({ showActionButtons: true, showOtherButton: false });
    } else {
      this.setState({ showActionButtons: false, showOtherButton: true });
    }
  }

  onEditorChange(content) {
    this.setState({ usingEditor: true, testTemplateToShow: content });
  }

  handleEventChange = (eventId) => {
    const selectedEvent = this.props.events.find((e) => e.id == eventId);
    this.setState({ selectedEvent, selectedActivity: null });
  };

  handleActivityChange = (activityId) => {
    const selectedActivity = this.state.selectedEvent.activities.find(
      (a) => a.id == activityId
    );
    this.setState({ selectedActivity });
  };

  render() {
    const { showEvents, selectedEvent, selectedActivity } = this.state;
    const { events } = this.props;
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          padding: "5px",
          height: "100%",
        }}
      >
        <ReactTooltip />

        {this.state.displayAutoFillPopup && (
          <Popup
            title="Auto fill Data"
            height="500px"
            maxWidth="750px"
            onClose={this.closeAutoFillPopup.bind(this)}
          >
            <AutoFill
              bills={this.state.filteredAutoFillData}
              // type={
              //   this.state.formData[`${prefix}types0`]?.length > 0
              //     ? this.state.formData[`${prefix}types0`]
              //     : this.state.formData.types ===
              //       "Consolidated Electricity Bill"
              //     ? "console"
              //     : "sanction"
              // }
              type={this.state.filteredAutoFillData.type}
              typeMultiple={
                this.state.formData[
                  `${this.state.filteredAutoFillData.keys.multipleKey}`
                ]
              }
              // typeMultiple={
              //   this.state.formData[`${prefix}types0`]?.length > 0
              //     ? this.state.formData[`${elecKey}number${prefix}types00`]
              //     : this.state.formData[`number${prefix}expenses00`] ||
              //       this.state.formData.pum_totaltypes0
              // }
              handleAddAutoFillData={this.handleAddAutoFillData.bind(this)}
              existingBill={
                // this.state.formData[`${prefix}types0`] === "Single"
                this.state.formData[
                  `${this.state.filteredAutoFillData.keys.prefix}types0`
                ] === "Single"
                  ? this.state.seletedBill
                  : this.state.seletedBills
              }
            />
          </Popup>
        )}

        <div
          id="actionsButtons"
          className="none padding-0 p-sm-16"
          // style={{ textAlign: "end" }}
        >
          {(() => {
            if (this.state.showActionButtons == true) {
              return (
                <>
                  <ReactToPrint
                    documentTitle={
                      this.props.title + "_MyDocMaster_" + Date.now()
                    }
                    pageStyle={
                      "@media print { body { -webkit-print-color-adjust: exact; } @page { size: " +
                      this.state.pageType +
                      "; margin: " +
                      Number(this.state.printMarginTop) * 0.3937 +
                      "in " +
                      Number(this.state.printMarginRight) * 0.3937 +
                      "in " +
                      Number(this.state.printMarginBottom) * 0.3937 +
                      "in " +
                      Number(this.state.printMarginLeft) * 0.3937 +
                      "in!important }}"
                    }
                    trigger={() => {
                      // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                      // to the root node of the returned component as it will be overwritten.
                      return (
                        <button
                          id="docformprintbutton1"
                          style={{ fontSize: 16 }}
                          className="no_print mb-3 outlineButton"
                        >
                          <i
                            style={{ fontSize: 20 }}
                            className="fa fa-print"
                            aria-hidden="true"
                          ></i>{" "}
                          Print
                        </button>
                      );
                    }}
                    content={() => this.componentRef}
                  />

                  <button
                    className="ml-lg-2 mb-3 outlineButton"
                    onClick={() => this.sendDocToUser(-1, 0)}
                  >
                    <i
                      style={{ fontSize: 20 }}
                      className="fa fa-download"
                      aria-hidden="true"
                    ></i>{" "}
                    Download As Word/Docx
                  </button>

                  <button
                    style={{ fontSize: 16 }}
                    className="ml-lg-2 mb-3 outlineButton w-150"
                    onClick={() => this.setState({ showEditor: true })}
                  >
                    <i
                      style={{ fontSize: 20 }}
                      className="fa fa-edit"
                      aria-hidden="true"
                    ></i>{" "}
                    Edit
                  </button>

                  <button
                    style={{
                      fontSize: 16,
                      color: "white",
                      backgroundColor: "red",
                      border: "none",
                    }}
                    className="ml-lg-2 mb-3 outlineButton w-150"
                    onClick={() => {
                      // this.props.handleNavigation("/myDocFormRecords");
                      const targetRoute =
                        this.props.isOrgAccess == 3
                          ? "/myDocumentForms"
                          : "/myDocFormRecords";
                      this.props.handleNavigation(targetRoute);
                    }}
                  >
                    <i
                      style={{ fontSize: 20 }}
                      className="fa fa-times"
                      aria-hidden="true"
                    ></i>{" "}
                    Close
                  </button>
                </>
              );
            } else {
              return (
                <>
                  <button
                    id="confirmButton"
                    // style={{ fontSize: 16 }}
                    className="outlineButton mb-3"
                    onClick={() => {
                      this.confirmSubmittedForm();
                    }}
                  >
                    <i
                      style={{ fontSize: 20 }}
                      className="fa fa-check"
                      aria-hidden="true"
                    ></i>{" "}
                    Confirm
                  </button>

                  <button
                    style={{ fontSize: 16 }}
                    className="outlineButton mb-3 ml-lg-2 w-150"
                    onClick={() => {
                      document
                        .querySelector("#docFormInputFields")
                        .classList.remove("none");
                      document
                        .querySelector("#editDocFormDiv")
                        .classList.remove("none");

                      document
                        .querySelector("#actionsButtons")
                        .classList.add("none");
                      // document
                      //   .getElementById("TemplateToggle")
                      //   .classList.remove("HideTemplateToggleButton");
                      document
                        .getElementById("docFormPreview")
                        .classList.remove("width-78");
                    }}
                  >
                    <i
                      style={{ fontSize: 20 }}
                      className="fa fa-arrow-left"
                      aria-hidden="true"
                    ></i>{" "}
                    Back
                  </button>
                </>
              );
            }
          })()}
        </div>

        <div id="editDocFormDiv">
          Title: {this.props.title}
          {/* <button
            className="customSmallButton"
            onClick={() => this.editTitle()}
          >
            Edit
          </button> */}
        </div>

        <div className="form_container" id="formFieldsContainer">
          <div className="formFieldAndTemplateContainer">
            <div className="d-flex">
              <div
                className="col-4"
                style={{
                  height: "80vh",
                  overflowY: "scroll",
                  border: "2px solid #e5e5e5",
                  // marginLeft: "10px",
                }}
                id="docFormInputFields"
              >
                {this.state.displayAutofillBtn && (
                  <button
                    className="btn btn-primary"
                    onClick={this.handleAutoFillData.bind(this)}
                  >
                    Auto fill data
                  </button>
                )}
                {this.state.excludeHolidayForms?.includes(
                  this.state.formId
                ) && (
                  <button
                    className="btn btn-primary"
                    // onClick={this.getHallDetails.bind(this)}
                    onClick={this.getHallDetails2.bind(this)}
                  >
                    Auto Fill Data
                  </button>
                )}
                {this.state.isHallopen && (
                  <Popup
                    title="Select Hall Data"
                    onClose={() => this.setState({ isHallopen: false })}
                    height="300px"
                    maxWidth="500px"
                  >
                    <div style={{ textAlign: "center" }}>
                      <h3>Select Hall Name</h3>
                      <select
                        value={JSON.stringify(this.state.selectedHallData)}
                        onChange={(e) =>
                          this.setState({
                            selectedHallData: JSON.parse(e.target.value),
                          })
                        }
                        style={{ width: "80%", padding: "8px" }}
                      >
                        <option value="">Select a Hall</option>
                        {this.state.hallData.map((hall, index) => (
                          <option key={index} value={JSON.stringify(hall)}>
                            {hall.hall_name}
                          </option>
                        ))}
                      </select>
                      <br />
                      <br />
                      {this.state.selectedHallData &&
                        Object.keys(this.state.selectedHallData).length > 0 && (
                          <div
                            style={{
                              border: "1px solid #ddd",
                              padding: "5px",
                              marginBottom: "20px",
                              marginTop: "10px",
                              background: "#f9f9f9",
                              borderRadius: "10px",
                              textAlign: "left",
                              width: "60%",
                              justifyContent: "center",
                              marginLeft: "75px",
                            }}
                          >
                            <strong>Selected Hall:</strong>{" "}
                            {this.state.selectedHallData.hall_name}
                            <br />
                            <strong>Area:</strong>{" "}
                            {this.state.selectedHallData.area} sq. ft.
                            <br />
                            <strong>Open Area:</strong>{" "}
                            {this.state.selectedHallData.open_area} sq. ft.
                            <br />
                            {(() => {
                              const startDate = moment(
                                this.state.formData.start_date,
                                "DD-MM-YYYY"
                              );
                              const isMarchToAugust =
                                startDate.month() >= 2 &&
                                startDate.month() <= 7;

                              return (
                                <>
                                  <strong>Exhibition Rate:</strong>{" "}
                                  {isMarchToAugust
                                    ? this.state.selectedHallData
                                        .exhibition_rate
                                    : this.state.selectedHallData
                                        .peak_exhibition_rate}
                                  <br />
                                  {/* <strong>Mounting Rate:</strong>{" "}
                                  {isMarchToAugust
                                    ? this.state.selectedHallData.mounting_rate
                                    : this.state.selectedHallData
                                        .peak_mounting_rate} */}
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={this.state.includeMountingRate}
                                      onChange={(e) =>
                                        this.setState({
                                          includeMountingRate: e.target.checked,
                                        })
                                      }
                                    />{" "}
                                    <strong>Include Mounting Rate</strong> (
                                    {isMarchToAugust
                                      ? this.state.selectedHallData
                                          .mounting_rate
                                      : this.state.selectedHallData
                                          .peak_mounting_rate}
                                    )
                                  </label>
                                  <br />
                                  {/* <strong>Open Area Rate:</strong>{" "}
                                  {isMarchToAugust
                                    ? this.state.selectedHallData
                                        .lean_open_area_rate
                                    : this.state.selectedHallData
                                        .peak_open_area_rate} */}
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={this.state.includeOpenAreaRate}
                                      onChange={(e) =>
                                        this.setState({
                                          includeOpenAreaRate: e.target.checked,
                                        })
                                      }
                                      disabled={true}
                                    />{" "}
                                    <strong>Include Open Area Rate</strong> (
                                    {isMarchToAugust
                                      ? this.state.selectedHallData
                                          .lean_open_area_rate
                                      : this.state.selectedHallData
                                          .peak_open_area_rate}
                                    )
                                  </label>
                                  <br />
                                </>
                              );
                            })()}
                            {/* <strong>AC Rate:</strong>{" "}
                            {this.state.selectedHallData.ac_rate} */}
                            <label>
                              <input
                                type="checkbox"
                                checked={this.state.includeAcRate}
                                onChange={(e) =>
                                  this.setState({
                                    includeAcRate: e.target.checked,
                                  })
                                }
                                disabled={true}
                              />{" "}
                              <strong>Include AC Rate </strong>(
                              {this.state.selectedHallData.ac_rate} )
                            </label>
                            <br />
                            {/* <strong>Water Rate:</strong>{" "} */}
                            {/* {this.state.selectedHallData.water_rate} */}
                            <label>
                              <input
                                type="checkbox"
                                checked={this.state.includeWaterRate}
                                onChange={(e) =>
                                  this.setState({
                                    includeWaterRate: e.target.checked,
                                  })
                                }
                                disabled={true}
                              />{" "}
                              <strong>Include Water Rate</strong> (
                              {this.state.selectedHallData.water_rate})
                            </label>
                            <br />
                            {/* <strong>Standing Light Rate:</strong>{" "}
                            {this.state.selectedHallData.standing_light_rate} */}
                            <label>
                              <input
                                type="checkbox"
                                checked={this.state.includeStandingLightRate}
                                onChange={(e) =>
                                  this.setState({
                                    includeStandingLightRate: e.target.checked,
                                  })
                                }
                                disabled={true}
                              />{" "}
                              <strong>Include Standing Light Rate</strong> (
                              {this.state.selectedHallData.standing_light_rate})
                            </label>
                          </div>
                        )}
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.setState({ isHallopen: false });
                          if (this.state.selectedHallData) {
                            this.getHallDetails(
                              this.state.selectedHallData,
                              this.state.includeWaterRate,
                              this.state.includeStandingLightRate,
                              this.state.includeAcRate,
                              this.state.includeOpenAreaRate,
                              this.state.includeMountingRate
                            );
                          }
                        }}
                      >
                        Save & Close
                      </button>
                    </div>
                  </Popup>
                )}
                {this.state.showEvents && (
                  <Popup
                    title="Select Event Details"
                    onClose={() => this.setState({ showEvents: false })}
                    height="400px"
                    maxWidth="500px"
                  >
                    <div style={{ padding: "16px" }}>
                      {/* Event Dropdown */}
                      <label
                        htmlFor="event-select"
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          fontWeight: "500",
                          color: "#374151",
                          fontSize: "14px",
                        }}
                      >
                        Select Event
                      </label>
                      <select
                        id="event-select"
                        style={{
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          marginBottom: "16px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                          outline: "none",
                        }}
                        value={this.state.selectedEvent?.id || ""}
                        onChange={(e) => this.handleEventChange(e.target.value)}
                      >
                        <option value="">-- Select an Event --</option>
                        {this.props.events.map((event) => (
                          <option key={event.id} value={event.id}>
                            {event.name} ({event.date})
                          </option>
                        ))}
                      </select>

                      {/* Activity Dropdown */}
                      {this.state.selectedEvent && (
                        <>
                          <label
                            htmlFor="activity-select"
                            style={{
                              display: "block",
                              marginBottom: "6px",
                              fontWeight: "500",
                              color: "#374151",
                              fontSize: "14px",
                            }}
                          >
                            Select Activity
                          </label>
                          <select
                            id="activity-select"
                            style={{
                              display: "block",
                              width: "100%",
                              padding: "8px 12px",
                              marginBottom: "16px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                              outline: "none",
                            }}
                            value={this.state.selectedActivity?.id || ""}
                            onChange={(e) =>
                              this.handleActivityChange(e.target.value)
                            }
                            disabled={
                              !this.state.selectedEvent?.activities?.length
                            }
                          >
                            <option value="">-- Select an Activity --</option>
                            {this.state.selectedEvent.activities.map(
                              (activity) => (
                                <option key={activity.id} value={activity.id}>
                                  {activity.name}
                                </option>
                              )
                            )}
                          </select>
                        </>
                      )}

                      {/* Submit Button */}
                      <div style={{ textAlign: "right" }}>
                        <button
                          onClick={() => {
                            this.submitEventData(
                              this.state.selectedEvent,
                              this.state.selectedActivity
                            );
                            // console.log(
                            //   "Selected Event:",
                            //   this.state.selectedEvent
                            // );
                            // console.log(
                            //   "Selected Activity:",
                            //   this.state.selectedActivity
                            // );
                          }}
                          style={{
                            padding: "8px 16px",
                            backgroundColor: "#2563EB",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Popup>
                )}

                <div id="docFormInputFields">
                  <Form
                    id="myDocCoreForm"
                    className="row outTemplateSectionForPrintSelect"
                    // onSubmit={this.handleSubmitData.bind(this)}
                    onSubmit={this.onFormSubmit}
                  >
                    <ReactTooltip />

                    {this.state.formsFieldsDataSorted?.length > 0 &&
                      InputFieldRendring(
                        this.state.formsFieldsDataSorted,
                        this.state.conditionalFormInputs,
                        this.onInputChange.bind(this),
                        this.state.formData
                      )}
                  </Form>
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      marginLeft: "10px",
                      padding: "0px 0px 10px 0px",
                    }}
                  >
                    <button
                      id="saveDraftButton"
                      // className="outlineButton"
                      style={{
                        width: "20%",
                        // borderRadius: 0,
                      }}
                      type="button"
                      className="generalUserButtons no_print btn btn-outline-primary"
                      onClick={() => {
                        this.saveDocFormDraft();
                      }}
                    >
                      <i
                        style={{ fontSize: 20 }}
                        className="fa fa-floppy-o"
                        aria-hidden="true"
                      ></i>{" "}
                      Save
                    </button>
                    &nbsp; &nbsp;
                    <button
                      positive
                      form="myDocCoreForm"
                      className="generalUserButtons no_print btn btn-outline-primary mr-3"
                      content="Submit"
                      value="Submit"
                      label="Submit"
                      type="submit"
                      style={{
                        width: "20%",
                      }}
                      // onClick={(e) => {
                      //   handleSubmitData(e)
                      // }}
                      // onClick={this.handleSubmitData.bind(this)}
                    >
                      Submit
                    </button>
                    &nbsp; &nbsp;
                    <button
                      type="button"
                      className="generalUserButtons no_print btn btn-outline-primary"
                      onClick={() => {
                        if (this.props.userData.roles === "trial") {
                          return alert(
                            `You are currently in a trial period and cannot print this document.`
                          );
                        }
                        this.setState({ showFilledForm: true });
                      }}
                    >
                      Show Printable/Template
                    </button>
                    {/* <button
  positive
  form="myDocCoreForm"
  className="generalUserButtons no_print btn btn-outline-primary mr-3"
  content="Submit"
  value="Submit"
  label="Submit"
  type="submit"
  style={{ width: "20%" }}
  onClick={async (e) => {
    e.preventDefault(); // stop auto-submit first

    const updatedAccessData = await this.props.dispatch(GetUserAccessThunk());
    const totalRecords = updatedAccessData.payload?.[0]?.total_records;

    if (totalRecords >= 5) {
      alert("Limit has expired for demo user!");
      return; // stop further action
    }

    // ✅ If allowed, now submit form
    document.getElementById("myDocCoreForm").submit();
  }}
>
  Submit
</button>

                    &nbsp; &nbsp;
                    <button
  type="button"
  className="generalUserButtons no_print btn btn-outline-primary"
  onClick={async () => {
    const updatedAccessData = await this.props.dispatch(GetUserAccessThunk());

    const totalRecords = updatedAccessData.payload?.[0]?.total_records;

    if (totalRecords >= 5) {
      alert("Limit has expired for demo user!");
      return; // ⛔ Stop further execution
    }

    this.setState({ showFilledForm: true }); // ✅ Only runs if limit not reached
  }}
>
  Show Printable/Template
</button> */}
                  </div>
                </div>
              </div>
              <div
                id="docFormPreview"
                className="defaultDocForm showDocFormPreview pl-40 "
              >
                <div className="liveRenderingOfForm">
                  <div
                    id="contentToPrint"
                    ref={(el) => (this.componentRef = el)}
                    style={{
                      fontFamily: "'Times New Roman', Times, serif",
                    }}
                    className="contentToPrintTableProps"
                    dangerouslySetInnerHTML={{
                      __html: processPageBreak(this.state.testTemplateToShow),
                    }}
                  />
                </div>
              </div>
              <div
              // className="col-8 outTemplateSectionForPrintSelect px-3 "
              // style={
              // {
              // boxShadow: "0 0 5px gray",
              // height: "85vh",
              // overflowY: "scroll",
              // border: "2px solid #e5e5e5",
              // }
              // }
              // id="contentToPrint"
              >
                {/* {this.state.testTemplateToShow && (
                    <div
                      id="contentToPrintInner"
                      style={{
                        fontFamily: "'Times New Roman', Times, serif",
                      }}
                      className="contentToPrintTableProps"
                      ref={this.componentRef}
                      // ref={(el) => (this.componentRef = el)}
                      dangerouslySetInnerHTML={{
                        // __html: processPageBreak(templateData),
                        __html: processPageBreak(this.state.testTemplateToShow),
                      }}
                    />
                  )} */}

                <Modal
                  transparent={false}
                  ariaHideApp={false}
                  isOpen={this.state.showFilledForm}
                  onRequestClose={() => {
                    this.setState({ showFilledForm: false });
                  }}
                  // style={{ zIndex: "4" }}
                  style={{
                    overlay: {
                      zIndex: 9999,
                    },
                    content: {
                      zIndex: 10000,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      right: "auto",
                      bottom: "auto",
                      marginRight: "-50%",
                      transform: "translate(-50%, -50%)",
                      width: "90%",
                      maxHeight: "90vh",
                      overflow: "auto",
                    },
                  }}
                >
                  <div className="row">
                    <div className="col-6">
                      {/* "@media print { body { -webkit-print-color-adjust: exact; } @page { size: "+this.state.pageType+"; margin: 10mm !important }}" */}
                      {/* margin: top right bottom left */}
                      <ReactToPrint
                        documentTitle="MyDocMaster_TestRun_Print"
                        pageStyle={
                          "@media print { body { -webkit-print-color-adjust: exact;width: 98%; } @page { size: " +
                          this.state.pageType +
                          "; width: 100%; margin: " +
                          Number(this.state.printMarginTop) * 0.3937 +
                          "in " +
                          Number(this.state.printMarginRight) * 0.3937 +
                          "in " +
                          Number(this.state.printMarginBottom) * 0.3937 +
                          "in " +
                          Number(this.state.printMarginLeft) * 0.3937 +
                          "in!important }}"
                        }
                        trigger={() => {
                          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                          // to the root node of the returned component as it will be overwritten.
                          return (
                            <button className="no_print btn btn-outline-primary mb-3">
                              <i
                                style={{ fontSize: 20 }}
                                className="fa fa-print"
                                aria-hidden="true"
                              ></i>{" "}
                              Print
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                        // content={() => this.componentRef.current}
                      />
                      &nbsp; &nbsp;
                      <button
                        style={{ fontSize: 16 }}
                        className="no_print btn btn-outline-primary mb-3"
                        onClick={() => this.emailOrDownloadThisDoc(-1)}
                      >
                        Download(Word/docx)
                      </button>
                      &nbsp; &nbsp;
                    </div>
                    <div className="col-6" style={{ textAlign: "end" }}>
                      <span
                        className="pointer"
                        onClick={() => {
                          // this.setState({ : false });
                          // setShowFilledForm(false);
                          this.setState({ showFilledForm: false });
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        X
                      </span>
                    </div>
                  </div>
                  {this.state.testTemplateToShow && (
                    <div
                      id="filledDocForm"
                      className="outTemplateSectionForPrintSelect contentToPrintTableProps"
                      style={{
                        fontFamily: "'Times New Roman', Times, serif",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: processPageBreak(this.state.testTemplateToShow),
                      }}
                    />
                  )}
                </Modal>
              </div>
            </div>
          </div>
        </div>

        <div className="none" id="filledFormRealTimePreview">
          <div className="">
            <div className="col-lg-9 col-12 padding-0 pr-20">
              {/* <div className="categoryNameHeading p-sm-16">
                        <h2>{this.state.docForm.formNameTitle}</h2>
                      </div> */}
              <div className="">
                {document.addEventListener("contextmenu", (event) =>
                  event.preventDefault()
                )}

                <Modal
                  transparent={false}
                  ariaHideApp={false}
                  isOpen={this.state.showEditor}
                  style={{
                    overlay: {
                      // border: "1px solid gray",
                      // width: "45vw",
                      width: "99vw",
                      height: "100vh",
                      // left: "27%",
                      left: 0,
                      top: "0%",
                      // background: "transparent",
                      zIndex: "999",
                    },
                    content: {
                      left: "20%",
                      width: "70vw",
                      // background: "transparent",
                      // border: "none",
                      // boxShadow:"0 0 5px black"
                    },
                  }}
                  onRequestClose={() => {
                    this.setState({ showEditor: false });
                  }}
                >
                  <div style={{ textAlign: "" }}>
                    <button
                      onClick={() => {
                        this.setState({ showEditor: false });
                      }}
                      className="btn btn-sm btn-primary mb-1"
                    >
                      <i className="fa fa-floppy-o" aria-hidden="true"></i> Done
                    </button>
                  </div>

                  <div>
                    {/* TinyMce */}
                    <TinyMce
                      formId={0}
                      intitialContent={this.state.testTemplateToShow}
                      onEditorChange={this.onEditorChange.bind(this)}
                    />
                  </div>
                </Modal>
                <div>{this.state.errors}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function WrapComponent() {
  const { isOrgAccess } = useSelector((store) => store.eventOrganiser);
  const events = useSelector((state) => state.eventOrganiser.Events) || [];
  const { userAccessData2, userCountRestrictions2 } = useSelector(
    (state) => state.user
  );

  const userData = userStore((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const title = location.state?.nameTitle || "";
  const docForm = location.state?.docForm || null;
  const draftRecId = location.state?.draftDataRecId || 0;
  const from = location.state?.from || "";
  const [showCore, setShowCore] = useState(false);
  let filledDocForm = location.state?.filledDocForm;

  const [draft, setDraft] = useState({});
  const [docFormPreFills, setDocFormPreFills] = useState([]);
  const [formsFieldsDataThis, setFormsFieldsData] = useState();
  const [docFormTemplateData, setDocFormTemplateData] = useState("<p></p>");
  const [loader, setLoader] = useState(false);

  useEffect(function () {
    if (docForm) {
      fetchDocFormTemplateAndInputFields();
    } else {
      getUserPrefills();
    }

    dispatch(GetUserAccessThunk2());
  }, []);

  const handleNavigation = (route) => {
    navigate(route);
  };

  const fetchDocFormTemplateAndInputFields = () => {
    setLoader(true);
    toast.success("Loading Please Wait...", { autoClose: 50 });

    let requestTemplateAndFormFields = axios.get(
      WSGetDocFormFieldsTemplate2 + "/" + userData.id + "/" + docForm.formId,
      {
        headers: apiKeyHeader(),
      }
    );

    let requestOrgUserPreFillField = axios.get(
      // WsGetOrgUserPreFillField + "/" + userData.org.id + "/" + userData.id,
      // WsGetOrgUserPreFillField + "/" + userData.id + "/" + userData.id,
      WsGetOrgUserPreFillField2 + "/" + userData.id,
      {
        headers: apiKeyHeader(),
      }
    );

    let webServiceCalls = [
      requestTemplateAndFormFields,
      requestOrgUserPreFillField,
    ];
    if (draftRecId > 0) {
      const requestGetUserFilledDocForm = axios.get(
        WSGetMyFilledOrgDocForm2 + "/" + userData.id + "/" + draftRecId,
        {
          headers: apiKeyHeader(),
        }
      );
      webServiceCalls = [
        requestTemplateAndFormFields,
        requestOrgUserPreFillField,
        requestGetUserFilledDocForm,
      ];
    }

    axios
      .all(webServiceCalls)
      .then(
        axios.spread((...responses) => {
          console.log("FormFieldTemplate_responses", responses);
          let showCoreCount = 0;
          if (responses[0] != undefined && responses[0] != null) {
            const responseTemplateAndFormFields = responses[0].data;

            if (responseTemplateAndFormFields.result_code == 1) {
              setFormsFieldsData(
                responseTemplateAndFormFields.result_message?.fields
              );

              setDocFormTemplateData(
                responseTemplateAndFormFields.result_message?.template
              );

              showCoreCount = showCoreCount + 1;
            } else {
              toast.warn("No Template & Input Data found", { autoClose: 50 });
            }
          }

          if (responses[1] != undefined && responses[1] != null) {
            const responseOrgUserPreFillData = responses[1].data;

            if (responseOrgUserPreFillData.resultCode == 1) {
              setDocFormPreFills(
                processPrefills(responseOrgUserPreFillData.resultMessage)
              );
            }
          }

          if (responses[2] != undefined && responses[2] != null) {
            const responseDraftData = responses[2].data;

            console.log(
              "FormFieldTemplate_responseDraftData",
              responseDraftData
            );

            if (responseDraftData.result_code == 1) {
              setDraft({
                id: draftRecId,
                inputData: JSON.parse(
                  responseDraftData.result_message.inputData
                ),
                htmlData: responseDraftData.result_message.htmlData,
              });
            }
          }

          if (showCoreCount > 0) {
            setShowCore(true);
          }

          setLoader(false);
        })
      )
      .catch((error) => {
        console.error("FormFieldTemplate_error", error);
        setLoader(false);
      });
  };

  const getUserPrefills = async () => {
    setLoader(true);
    console.log(" this.userData?.id", userData);
    const responses = await axios.get(
      // WsGetOrgUserPreFillField + "/" + userData.org.id + "/" + userData.id,
      userPrefill2 + "/" + userData?.id,
      {
        headers: apiKeyHeader(),
      }
    );
    const responseOrgUserPreFillData = responses.data;

    // if (responseOrgUserPreFillData.resultCode == 1) {
    if (responseOrgUserPreFillData.length > 0) {
      setDocFormPreFills(
        // processPrefills(responseOrgUserPreFillData.resultMessage)
        processPrefills(responseOrgUserPreFillData)
      );
    }
    setLoader(false);
  };

  function processPrefills(data) {
    const processedData = data.map((e) => {
      return { ...e, field: e.field_key, fieldValue: e.field_value };
    });
    console.log("processedData", processedData);
    return processedData;
  }

  if (loader) return <div>Loading...</div>;

  return (
    <TestRunNew
      title={title}
      isOrgAccess={isOrgAccess}
      draft={draft}
      docForm={docForm}
      docFormPreFills={docFormPreFills}
      formsFieldsData={formsFieldsDataThis}
      formsTemplate={docFormTemplateData}
      from={from}
      handleNavigation={handleNavigation}
      events={events}
      dispatch={dispatch}
      navigate={navigate}
      location={location}
      userAccessData={userAccessData2}
      userCountRestrictions={userCountRestrictions2}
      userData={userData}
    />
  );
}

export default WrapComponent;
